var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublicServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e2p7re3xta",
    d: "M0.076 0.031L1.845 0.031 1.845 1.159 0.076 1.159z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8fr16rc56c",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "biczepzmye",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v45odou3og",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "067qp8np4i",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kikzncq5zk",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dliaudi93m",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "5a9f6046eo",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "scpm5mif1q",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x1sxyo4vas",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "2v4x5iebju",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g25y5k79hw",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s5efoyxvty",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c2gqfk4clA",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7t4c60t4rC",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "gxa3wvbbdE",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i2e54q6z8G",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hy5olnes3I",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "945pdl7gwK",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "43cxhvu0mM",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7py8mb32aO",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s9ced5zp3Q",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u8e9gtrrtS",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reauaknr6U",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyv5ipvkkW",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n4nl8n067Y",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "agd9v1y34aa",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak3tkqxlkac",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v03uzr850ae",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tqj1axoghag",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l9tjyvm10ai",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "5pt1rxnrqak",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7h3sap5x6am",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmw2pnks6ao",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "3bwr7fyu8aq",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6mi565t86as",
    d: "M.124 2.202c-.011 3.676 2.574 8.153 5.77 9.998l3.084-1.792C5.782 8.562 3.198 4.086 3.208.41L.124 2.202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1fyccr5ozau",
    d: "M.4 2.004H.4L3.124.421.399 2.004"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nlbgoogz3aw",
    d: "M.054 2.219l.003.003L3.141.43 3.138.426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "80rbyjcumay",
    d: "M.057 2.222l.027.028L3.169.458 3.14.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8jr301ofeaA",
    d: "M.084 2.25l.072.073L3.24.53 3.17.458.084 2.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nrb4dhwaeaC",
    d: "M.084 2.25l.072.073L3.24.53 3.17.458.084 2.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "60igle3ikaE",
    d: "M.38 2.031c.104.113.21.224.318.33L3.782.57C3.674.462 3.568.353 3.464.24L.38 2.031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vb9l70e5caG",
    d: "M.38 2.031c.104.113.21.224.318.33L3.782.57C3.674.462 3.568.353 3.464.24L.38 2.031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wk68to9djaI",
    d: "M.38 2.031c.104.113.21.224.318.33L3.782.57C3.674.462 3.568.353 3.464.24L.38 2.031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k8tkrxveeaK",
    d: "M.31 1.961l.003.006L3.397.175 3.395.169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "syh00fh2jaM",
    d: "M.302 1.928l.009.033L3.395.17l-.01-.034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "014l6olk9aO",
    d: "M.273 1.824l.029.104L3.386.135 3.358.032.273 1.824"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i5bj1ojjlaQ",
    d: "M.273 1.824l.029.104L3.386.135 3.358.032.273 1.824"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lzk1csyroaS",
    d: "M.261 2.282c.004.015.009.03.012.046L3.358.535C3.353.52 3.348.505 3.345.49L.261 2.282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0q9ol97kkaU",
    d: "M.26 2.277c.038.146.08.292.126.439L3.471.923C3.425.777 3.383.631 3.344.485L.26 2.277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9ux5kfbjyaW",
    d: "M.26 2.277c.038.146.08.292.126.439L3.471.923C3.425.777 3.383.631 3.344.485L.26 2.277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "42cy6w5rfaY",
    d: "M.26 2.277c.038.146.08.292.126.439L3.471.923C3.425.777 3.383.631 3.344.485L.26 2.277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "gbwu9y3szba",
    d: "M.229 2.156l.032.126L3.345.49 3.313.363.23 2.156"
  }), /*#__PURE__*/React.createElement("path", {
    id: "685akt1eabc",
    d: "M.22 2.121l.009.035L3.313.363 3.304.329.22 2.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u6r63rp7mbe",
    d: "M.22 2.121l.009.035L3.313.363 3.304.329.22 2.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pijb290rrbg",
    d: "M.203 2.05l.017.071L3.304.33C3.3.304 3.294.28 3.287.257"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k0cirrvqpbi",
    d: "M1.813 2.012C.773 2.615.129 3.899.123 5.724l3.085-1.792c.005-1.825.65-3.109 1.69-3.713L1.812 2.012"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v73wxqv8ubk",
    d: "M1.813 2.012C.773 2.615.129 3.899.123 5.724l3.085-1.792c.005-1.825.65-3.109 1.69-3.713L1.812 2.012"
  }), /*#__PURE__*/React.createElement("path", {
    id: "xt3dr7o22bm",
    d: "M1.813 2.012C.773 2.615.129 3.899.123 5.724l3.085-1.792c.005-1.825.65-3.109 1.69-3.713L1.812 2.012"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8mecr61i2bo",
    d: "M1.813 2.012C.773 2.615.129 3.899.123 5.724l3.085-1.792c.005-1.825.65-3.109 1.69-3.713L1.812 2.012"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m8776abz3bq",
    d: "M1.813 2.012C.773 2.615.129 3.899.123 5.724l3.085-1.792c.005-1.825.65-3.109 1.69-3.713L1.812 2.012"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ka1jpn0vzbs",
    d: "M1.813 2.012C.773 2.615.129 3.899.123 5.724l3.085-1.792c.005-1.825.65-3.109 1.69-3.713L1.812 2.012"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6791wmo60bu",
    d: "M1.813 2.012C.773 2.615.129 3.899.123 5.724l3.085-1.792c.005-1.825.65-3.109 1.69-3.713L1.812 2.012"
  }), /*#__PURE__*/React.createElement("path", {
    id: "inlhymy3qbw",
    d: "M1.813 2.012C.773 2.615.129 3.899.123 5.724l3.085-1.792c.005-1.825.65-3.109 1.69-3.713L1.812 2.012"
  }), /*#__PURE__*/React.createElement("path", {
    id: "abaaemxsmby",
    d: "M1.813 2.012C.773 2.615.129 3.899.123 5.724l3.085-1.792c.005-1.825.65-3.109 1.69-3.713L1.812 2.012"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d539maajfbA",
    d: "M1.813 2.012C.773 2.615.129 3.899.123 5.724l3.085-1.792c.005-1.825.65-3.109 1.69-3.713L1.812 2.012"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aeew5f0ncbC",
    d: "M1.813 2.012C.773 2.615.129 3.899.123 5.724l3.085-1.792c.005-1.825.65-3.109 1.69-3.713L1.812 2.012"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1ut4sy8jnbE",
    d: "M.36 2.137c1.609.93 3.067 1.016 4.12.404L7.566.749c-1.054.612-2.512.525-4.121-.404L.359 2.137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kcq1go0fybG",
    d: "M.36 2.137c1.609.93 3.067 1.016 4.12.404L7.566.749c-1.054.612-2.512.525-4.121-.404L.359 2.137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "olq8bomqrbI",
    d: "M.36 2.137c1.609.93 3.067 1.016 4.12.404L7.566.749c-1.054.612-2.512.525-4.121-.404L.359 2.137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "oh1kvricmbK",
    d: "M.36 2.137c1.609.93 3.067 1.016 4.12.404L7.566.749c-1.054.612-2.512.525-4.121-.404L.359 2.137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4qtdjlmambM",
    d: "M.36 2.137c1.609.93 3.067 1.016 4.12.404L7.566.749c-1.054.612-2.512.525-4.121-.404L.359 2.137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sze0msbdabO",
    d: "M.36 2.137c1.609.93 3.067 1.016 4.12.404L7.566.749c-1.054.612-2.512.525-4.121-.404L.359 2.137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t8xvzrn5wbQ",
    d: "M.36 2.137c1.609.93 3.067 1.016 4.12.404L7.566.749c-1.054.612-2.512.525-4.121-.404L.359 2.137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "qhc56q68gbS",
    d: "M.36 2.137c1.609.93 3.067 1.016 4.12.404L7.566.749c-1.054.612-2.512.525-4.121-.404L.359 2.137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kfjkmiyqdbU",
    d: "M.36 2.137c1.609.93 3.067 1.016 4.12.404L7.566.749c-1.054.612-2.512.525-4.121-.404L.359 2.137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9n5i3o3wkbW",
    d: "M.36 2.137c1.609.93 3.067 1.016 4.12.404L7.566.749c-1.054.612-2.512.525-4.121-.404L.359 2.137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "40e49z671bY",
    d: "M.36 2.137c1.609.93 3.067 1.016 4.12.404L7.566.749c-1.054.612-2.512.525-4.121-.404L.359 2.137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "roys96kvhca",
    d: "M.36 2.137c1.609.93 3.067 1.016 4.12.404L7.566.749c-1.054.612-2.512.525-4.121-.404L.359 2.137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kq1gsly34cc",
    d: "M.36 2.137c1.609.93 3.067 1.016 4.12.404L7.566.749c-1.054.612-2.512.525-4.121-.404L.359 2.137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0h88ga05bce",
    d: "M.36 2.137c1.609.93 3.067 1.016 4.12.404L7.566.749c-1.054.612-2.512.525-4.121-.404L.359 2.137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w4znrz441cg",
    d: "M.36 2.137c1.609.93 3.067 1.016 4.12.404L7.566.749c-1.054.612-2.512.525-4.121-.404L.359 2.137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fddndu4teci",
    d: "M.362 2.256l.048.01L3.493.472l-.046-.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kc1mg0wklck",
    d: "M.41 2.265l.044.009L3.538.48 3.493.473C2.438.65 1.335 1.727.41 2.265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3cv422rlcm",
    d: "M.41 2.265l.044.009L3.538.48 3.493.473C2.438.65 1.335 1.727.41 2.265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fek8zjc3oco",
    d: "M.454 2.274l.08.013L3.618.495l-.08-.014C2.483.664 1.378 1.736.454 2.274"
  }), /*#__PURE__*/React.createElement("path", {
    id: "symbmnnjkcq",
    d: "M.03 2.287l.04.006L3.155.501l-.04-.006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "qxprn6vhtcs",
    d: "M.07 2.293l.065.01L3.22.51 3.155.501"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nihjjydb9cu",
    d: "M.07 2.293l.065.01L3.22.51 3.155.501"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1s83gqtqacw",
    d: "M.135 1.8l.034.004L3.254.01C3.243.011 3.23.01 3.22.007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "gvafyfqyocy",
    d: "M.17 1.804h.003L3.257.013h-.003"
  }), /*#__PURE__*/React.createElement("path", {
    id: "jryqr0gytcA",
    d: "M.068 1.799c.044.15.096.302.157.45L3.31.458c-.062-.15-.114-.3-.157-.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "drz20jbb7cC",
    d: "M.068 1.799c.044.15.096.302.157.45L3.31.458c-.062-.15-.114-.3-.157-.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uy51bwjmmcE",
    d: "M.068 1.799c.044.15.096.302.157.45L3.31.458c-.062-.15-.114-.3-.157-.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e9ucfqon0cG",
    d: "M.068 1.799c.044.15.096.302.157.45L3.31.458c-.062-.15-.114-.3-.157-.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0ty9ks4h5cI",
    d: "M.068 1.799c.044.15.096.302.157.45L3.31.458c-.062-.15-.114-.3-.157-.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tk6937rcucK",
    d: "M.157 2.186c.222.23.464.425.718.57.255.149.498.232.721.26l3.085-1.793c-.224-.027-.467-.111-.722-.258-.253-.146-.495-.342-.718-.572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "5wshu40pvcM",
    d: "M.157 2.186c.222.23.464.425.718.57.255.149.498.232.721.26l3.085-1.793c-.224-.027-.467-.111-.722-.258-.253-.146-.495-.342-.718-.572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dd8y3aytzcO",
    d: "M.157 2.186c.222.23.464.425.718.57.255.149.498.232.721.26l3.085-1.793c-.224-.027-.467-.111-.722-.258-.253-.146-.495-.342-.718-.572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s9iwcsk6zcQ",
    d: "M.157 2.186c.222.23.464.425.718.57.255.149.498.232.721.26l3.085-1.793c-.224-.027-.467-.111-.722-.258-.253-.146-.495-.342-.718-.572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f90x28cvecS",
    d: "M.157 2.186c.222.23.464.425.718.57.255.149.498.232.721.26l3.085-1.793c-.224-.027-.467-.111-.722-.258-.253-.146-.495-.342-.718-.572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g65j9df1fcU",
    d: "M.157 2.186c.222.23.464.425.718.57.255.149.498.232.721.26l3.085-1.793c-.224-.027-.467-.111-.722-.258-.253-.146-.495-.342-.718-.572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0lnnqg123cW",
    d: "M.157 2.186c.222.23.464.425.718.57.255.149.498.232.721.26l3.085-1.793c-.224-.027-.467-.111-.722-.258-.253-.146-.495-.342-.718-.572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wb26eswiucY",
    d: "M.157 2.186c.222.23.464.425.718.57.255.149.498.232.721.26l3.085-1.793c-.224-.027-.467-.111-.722-.258-.253-.146-.495-.342-.718-.572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "069vcj1n7da",
    d: "M.157 2.186c.222.23.464.425.718.57.255.149.498.232.721.26l3.085-1.793c-.224-.027-.467-.111-.722-.258-.253-.146-.495-.342-.718-.572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l2oi4rvzfdc",
    d: "M.157 2.186c.222.23.464.425.718.57.255.149.498.232.721.26l3.085-1.793c-.224-.027-.467-.111-.722-.258-.253-.146-.495-.342-.718-.572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8m72eyc9dde",
    d: "M.157 2.186c.222.23.464.425.718.57.255.149.498.232.721.26l3.085-1.793c-.224-.027-.467-.111-.722-.258-.253-.146-.495-.342-.718-.572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tty9kr3ogdg",
    d: "M.157 2.186c.222.23.464.425.718.57.255.149.498.232.721.26l3.085-1.793c-.224-.027-.467-.111-.722-.258-.253-.146-.495-.342-.718-.572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9jswdmotvdi",
    d: "M.157 2.186c.222.23.464.425.718.57.255.149.498.232.721.26l3.085-1.793c-.224-.027-.467-.111-.722-.258-.253-.146-.495-.342-.718-.572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uw6ww7xfjdk",
    d: "M.157 2.186c.222.23.464.425.718.57.255.149.498.232.721.26l3.085-1.793c-.224-.027-.467-.111-.722-.258-.253-.146-.495-.342-.718-.572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "drbm8mwtidm",
    d: "M.157 2.186c.222.23.464.425.718.57.255.149.498.232.721.26l3.085-1.793c-.224-.027-.467-.111-.722-.258-.253-.146-.495-.342-.718-.572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dztfowab1do",
    d: "M.157 2.186c.222.23.464.425.718.57.255.149.498.232.721.26l3.085-1.793c-.224-.027-.467-.111-.722-.258-.253-.146-.495-.342-.718-.572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9icajel8zdq",
    d: "M.157 2.186c.222.23.464.425.718.57.255.149.498.232.721.26l3.085-1.793c-.224-.027-.467-.111-.722-.258-.253-.146-.495-.342-.718-.572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k0ldbritzds",
    d: "M.157 2.186c.222.23.464.425.718.57.255.149.498.232.721.26l3.085-1.793c-.224-.027-.467-.111-.722-.258-.253-.146-.495-.342-.718-.572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poku69xq9du",
    d: "M.157 2.186c.222.23.464.425.718.57.255.149.498.232.721.26l3.085-1.793c-.224-.027-.467-.111-.722-.258-.253-.146-.495-.342-.718-.572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4nb906o28dw",
    d: "M.576 2.161c-.088.205-.137.455-.138.747-.001.29.047.597.134.903L3.656 2.02c-.088-.306-.135-.613-.134-.904.001-.291.05-.541.138-.747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lk0kr6y8ddy",
    d: "M.576 2.161c-.088.205-.137.455-.138.747-.001.29.047.597.134.903L3.656 2.02c-.088-.306-.135-.613-.134-.904.001-.291.05-.541.138-.747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w63pnj6krdA",
    d: "M.576 2.161c-.088.205-.137.455-.138.747-.001.29.047.597.134.903L3.656 2.02c-.088-.306-.135-.613-.134-.904.001-.291.05-.541.138-.747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q8ywp7odrdC",
    d: "M.576 2.161c-.088.205-.137.455-.138.747-.001.29.047.597.134.903L3.656 2.02c-.088-.306-.135-.613-.134-.904.001-.291.05-.541.138-.747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "yha0p08oudE",
    d: "M.576 2.161c-.088.205-.137.455-.138.747-.001.29.047.597.134.903L3.656 2.02c-.088-.306-.135-.613-.134-.904.001-.291.05-.541.138-.747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tfzyqq3yldG",
    d: "M.576 2.161c-.088.205-.137.455-.138.747-.001.29.047.597.134.903L3.656 2.02c-.088-.306-.135-.613-.134-.904.001-.291.05-.541.138-.747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0sk6leyjhdI",
    d: "M.576 2.161c-.088.205-.137.455-.138.747-.001.29.047.597.134.903L3.656 2.02c-.088-.306-.135-.613-.134-.904.001-.291.05-.541.138-.747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1vadpknfddK",
    d: "M.576 2.161c-.088.205-.137.455-.138.747-.001.29.047.597.134.903L3.656 2.02c-.088-.306-.135-.613-.134-.904.001-.291.05-.541.138-.747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1yi3buvbpdM",
    d: "M.576 2.161c-.088.205-.137.455-.138.747-.001.29.047.597.134.903L3.656 2.02c-.088-.306-.135-.613-.134-.904.001-.291.05-.541.138-.747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "2ok17cscgdO",
    d: "M.576 2.161c-.088.205-.137.455-.138.747-.001.29.047.597.134.903L3.656 2.02c-.088-.306-.135-.613-.134-.904.001-.291.05-.541.138-.747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9ptccgdjtdQ",
    d: "M.576 2.161c-.088.205-.137.455-.138.747-.001.29.047.597.134.903L3.656 2.02c-.088-.306-.135-.613-.134-.904.001-.291.05-.541.138-.747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bfxb4sh0bdS",
    d: "M.576 2.161c-.088.205-.137.455-.138.747-.001.29.047.597.134.903L3.656 2.02c-.088-.306-.135-.613-.134-.904.001-.291.05-.541.138-.747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "payj5n7b3dU",
    d: "M.576 2.161c-.088.205-.137.455-.138.747-.001.29.047.597.134.903L3.656 2.02c-.088-.306-.135-.613-.134-.904.001-.291.05-.541.138-.747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ns1ts6sabdW",
    d: "M.576 2.161c-.088.205-.137.455-.138.747-.001.29.047.597.134.903L3.656 2.02c-.088-.306-.135-.613-.134-.904.001-.291.05-.541.138-.747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "txijde3yndY",
    d: "M.576 2.161c-.088.205-.137.455-.138.747-.001.29.047.597.134.903L3.656 2.02c-.088-.306-.135-.613-.134-.904.001-.291.05-.541.138-.747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n4yrs3iy7ea",
    d: "M.576 2.161c-.088.205-.137.455-.138.747-.001.29.047.597.134.903L3.656 2.02c-.088-.306-.135-.613-.134-.904.001-.291.05-.541.138-.747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "xk9toiji4ec",
    d: "M.576 2.161c-.088.205-.137.455-.138.747-.001.29.047.597.134.903L3.656 2.02c-.088-.306-.135-.613-.134-.904.001-.291.05-.541.138-.747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "oc9pm9xcgee",
    d: "M.576 2.161c-.088.205-.137.455-.138.747-.001.29.047.597.134.903L3.656 2.02c-.088-.306-.135-.613-.134-.904.001-.291.05-.541.138-.747L.576 2.161z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6d82esu2qeg",
    d: "M.17 1.98c-.037.056-.069.116-.097.181L3.157.368c.028-.064.06-.124.096-.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cflp5rjrqei",
    d: "M.17 1.98c-.037.056-.069.116-.097.181L3.157.368c.028-.064.06-.124.096-.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dlua1f33uek",
    d: "M.17 1.98c-.037.056-.069.116-.097.181L3.157.368c.028-.064.06-.124.096-.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u4jubtjilem",
    d: "M2.893.398L.17 1.98c.086.09.178.167.274.229L3.527.416c-.096-.061-.188-.14-.274-.228l-.36.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4eeqesf6qeo",
    d: "M2.893.398L.17 1.98c.086.09.178.167.274.229L3.527.416c-.096-.061-.188-.14-.274-.228l-.36.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "66u1dhyjveq",
    d: "M2.893.398L.17 1.98c.086.09.178.167.274.229L3.527.416c-.096-.061-.188-.14-.274-.228l-.36.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "oy0ckuhc6es",
    d: "M2.893.398L.17 1.98c.086.09.178.167.274.229L3.527.416c-.096-.061-.188-.14-.274-.228l-.36.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "yuz5pyczueu",
    d: "M2.893.398L.17 1.98c.086.09.178.167.274.229L3.527.416c-.096-.061-.188-.14-.274-.228l-.36.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y7savtaanew",
    d: "M2.893.398L.17 1.98c.086.09.178.167.274.229L3.527.416c-.096-.061-.188-.14-.274-.228l-.36.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j6mskrvrney",
    d: "M2.893.398L.17 1.98c.086.09.178.167.274.229L3.527.416c-.096-.061-.188-.14-.274-.228l-.36.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7pc0eeoseeA",
    d: "M2.893.398L.17 1.98c.086.09.178.167.274.229L3.527.416c-.096-.061-.188-.14-.274-.228l-.36.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "xs14womgfeC",
    d: "M.443 2.209l.053.032L3.581.449 3.527.416.443 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wg8skzn1aeE",
    d: "M.443 2.209l.053.032L3.581.449 3.527.416.443 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "xrnxy8vbweG",
    d: "M.443 2.209l.053.032L3.581.449 3.527.416.443 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "91z3yzafjeI",
    d: "M.03 1.8c.06.147.112.297.155.446L3.269.454c-.043-.15-.095-.299-.155-.446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "heyrzjfqceK",
    d: "M.03 1.8c.06.147.112.297.155.446L3.269.454c-.043-.15-.095-.299-.155-.446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tx5uospsueM",
    d: "M.03 1.8c.06.147.112.297.155.446L3.269.454c-.043-.15-.095-.299-.155-.446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rus3u1hm7eO",
    d: "M.03 1.8c.06.147.112.297.155.446L3.269.454c-.043-.15-.095-.299-.155-.446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ujz43tz7neQ",
    d: "M.03 1.8c.06.147.112.297.155.446L3.269.454c-.043-.15-.095-.299-.155-.446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cs6filxdleS",
    d: "M.099 1.862c.108.112.211.232.31.359L3.492.429c-.098-.127-.201-.247-.31-.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d4msj4bn3eU",
    d: "M.099 1.862c.108.112.211.232.31.359L3.492.429c-.098-.127-.201-.247-.31-.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ms44eblkveW",
    d: "M.099 1.862c.108.112.211.232.31.359L3.492.429c-.098-.127-.201-.247-.31-.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a54cjv7a1eY",
    d: "M.099 1.862c.108.112.211.232.31.359L3.492.429c-.098-.127-.201-.247-.31-.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8ytmtyu73fa",
    d: "M.099 1.862c.108.112.211.232.31.359L3.492.429c-.098-.127-.201-.247-.31-.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "zdctcj09ofc",
    d: "M.444 2.078l.012.043.027.097.013.05.03.118.011.045.017.068L3.638.706 3.622.638l-.01-.043-.032-.12-.013-.049L3.54.33 3.528.286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vee4xg59ife",
    d: "M.444 2.078l.012.043.027.097.013.05.03.118.011.045.017.068L3.638.706 3.622.638l-.01-.043-.032-.12-.013-.049L3.54.33 3.528.286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ed0iyvu3ifg",
    d: "M.444 2.078l.012.043.027.097.013.05.03.118.011.045.017.068L3.638.706 3.622.638l-.01-.043-.032-.12-.013-.049L3.54.33 3.528.286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6h6lujvfvfi",
    d: "M1.438 2.233C1.19 2.807.817 3.237.351 3.508l3.084-1.792c.466-.271.839-.702 1.088-1.275"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9xqmzr02xfk",
    d: "M1.438 2.233C1.19 2.807.817 3.237.351 3.508l3.084-1.792c.466-.271.839-.702 1.088-1.275"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8z915i4h6fm",
    d: "M1.438 2.233C1.19 2.807.817 3.237.351 3.508l3.084-1.792c.466-.271.839-.702 1.088-1.275"
  }), /*#__PURE__*/React.createElement("path", {
    id: "usqi1tz7efo",
    d: "M3.419.215c-.9.519-1.796 1.043-2.693 1.566L3.422.214 3.42.215M.35 2l-.016.01.391-.228"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tz76t6rxrfq",
    d: "M1.412 2.047c-.466.271-.838.701-1.087 1.274L3.409 1.53C3.658.956 4.03.525 4.496.255L1.412 2.047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f0inad6tlfs",
    d: "M1.412 2.047c-.466.271-.838.701-1.087 1.274L3.409 1.53C3.658.956 4.03.525 4.496.255L1.412 2.047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "umonx0qjxfu",
    d: "M1.412 2.047c-.466.271-.838.701-1.087 1.274L3.409 1.53C3.658.956 4.03.525 4.496.255L1.412 2.047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m1lgzp1umfw",
    d: "M3.49.758L.406 2.551c.477-.277 1.05-.387 1.69-.31L5.18.45C5.047.433 4.916.425 4.788.425c-.483 0-.92.114-1.298.333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4a46p7hwlfy",
    d: "M3.49.758L.406 2.551c.477-.277 1.05-.387 1.69-.31L5.18.45C5.047.433 4.916.425 4.788.425c-.483 0-.92.114-1.298.333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "55ptqp68cfA",
    d: "M3.49.758L.406 2.551c.477-.277 1.05-.387 1.69-.31L5.18.45C5.047.433 4.916.425 4.788.425c-.483 0-.92.114-1.298.333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tcamkmyc6fC",
    d: "M3.49.758L.406 2.551c.477-.277 1.05-.387 1.69-.31L5.18.45C5.047.433 4.916.425 4.788.425c-.483 0-.92.114-1.298.333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fvofox1tifE",
    d: "M3.49.758L.406 2.551c.477-.277 1.05-.387 1.69-.31L5.18.45C5.047.433 4.916.425 4.788.425c-.483 0-.92.114-1.298.333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h7ethmgnmfG",
    d: "M3.49.758L.406 2.551c.477-.277 1.05-.387 1.69-.31L5.18.45C5.047.433 4.916.425 4.788.425c-.483 0-.92.114-1.298.333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "yi2kt8r20fI",
    d: "M.084 2.242l.026.003.079.011.031.005c.033.005.065.01.097.017.007 0 .013.002.02.003L3.42.49c-.007 0-.013-.002-.02-.004L3.305.468 3.273.463l-.078-.01-.027-.004"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hxt11i4y3fK",
    d: "M.084 2.242l.026.003.079.011.031.005c.033.005.065.01.097.017.007 0 .013.002.02.003L3.42.49c-.007 0-.013-.002-.02-.004L3.305.468 3.273.463l-.078-.01-.027-.004"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kgi8cm6wcfM",
    d: "M.084 2.242l.026.003.079.011.031.005c.033.005.065.01.097.017.007 0 .013.002.02.003L3.42.49c-.007 0-.013-.002-.02-.004L3.305.468 3.273.463l-.078-.01-.027-.004"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k8mmkr320fO",
    d: "M.084 2.242l.026.003.079.011.031.005c.033.005.065.01.097.017.007 0 .013.002.02.003L3.42.49c-.007 0-.013-.002-.02-.004L3.305.468 3.273.463l-.078-.01-.027-.004"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0nzrg0kw9fQ",
    d: "M.394 2.293c.476.099.983.297 1.51.6.526.304 1.033.692 1.508 1.142l3.084-1.793c-.475-.45-.982-.837-1.508-1.14C4.462.796 3.954.598 3.478.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0kcc4xgjtfS",
    d: "M.394 2.293c.476.099.983.297 1.51.6.526.304 1.033.692 1.508 1.142l3.084-1.793c-.475-.45-.982-.837-1.508-1.14C4.462.796 3.954.598 3.478.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rscm4v3wqfU",
    d: "M.394 2.293c.476.099.983.297 1.51.6.526.304 1.033.692 1.508 1.142l3.084-1.793c-.475-.45-.982-.837-1.508-1.14C4.462.796 3.954.598 3.478.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "2gcae6p5jfW",
    d: "M.394 2.293c.476.099.983.297 1.51.6.526.304 1.033.692 1.508 1.142l3.084-1.793c-.475-.45-.982-.837-1.508-1.14C4.462.796 3.954.598 3.478.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "zgh38vxrefY",
    d: "M.394 2.293c.476.099.983.297 1.51.6.526.304 1.033.692 1.508 1.142l3.084-1.793c-.475-.45-.982-.837-1.508-1.14C4.462.796 3.954.598 3.478.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "okurwjb7sga",
    d: "M.394 2.293c.476.099.983.297 1.51.6.526.304 1.033.692 1.508 1.142l3.084-1.793c-.475-.45-.982-.837-1.508-1.14C4.462.796 3.954.598 3.478.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mp0h4sg9agc",
    d: "M.394 2.293c.476.099.983.297 1.51.6.526.304 1.033.692 1.508 1.142l3.084-1.793c-.475-.45-.982-.837-1.508-1.14C4.462.796 3.954.598 3.478.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w860c44yige",
    d: "M.394 2.293c.476.099.983.297 1.51.6.526.304 1.033.692 1.508 1.142l3.084-1.793c-.475-.45-.982-.837-1.508-1.14C4.462.796 3.954.598 3.478.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "auhpl4twbgg",
    d: "M.394 2.293c.476.099.983.297 1.51.6.526.304 1.033.692 1.508 1.142l3.084-1.793c-.475-.45-.982-.837-1.508-1.14C4.462.796 3.954.598 3.478.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6jgfshiihgi",
    d: "M.394 2.293c.476.099.983.297 1.51.6.526.304 1.033.692 1.508 1.142l3.084-1.793c-.475-.45-.982-.837-1.508-1.14C4.462.796 3.954.598 3.478.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "gs8qfyxbwgk",
    d: "M.394 2.293c.476.099.983.297 1.51.6.526.304 1.033.692 1.508 1.142l3.084-1.793c-.475-.45-.982-.837-1.508-1.14C4.462.796 3.954.598 3.478.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "3rzswm84egm",
    d: "M.394 2.293c.476.099.983.297 1.51.6.526.304 1.033.692 1.508 1.142l3.084-1.793c-.475-.45-.982-.837-1.508-1.14C4.462.796 3.954.598 3.478.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0c9cum49xgo",
    d: "M.394 2.293c.476.099.983.297 1.51.6.526.304 1.033.692 1.508 1.142l3.084-1.793c-.475-.45-.982-.837-1.508-1.14C4.462.796 3.954.598 3.478.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hd77tntfigq",
    d: "M.394 2.293c.476.099.983.297 1.51.6.526.304 1.033.692 1.508 1.142l3.084-1.793c-.475-.45-.982-.837-1.508-1.14C4.462.796 3.954.598 3.478.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kt9ig6vzqgs",
    d: "M.394 2.293c.476.099.983.297 1.51.6.526.304 1.033.692 1.508 1.142l3.084-1.793c-.475-.45-.982-.837-1.508-1.14C4.462.796 3.954.598 3.478.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hswebrkvugu",
    d: "M3.388.723L.303 2.515c1.053-.612 2.511-.526 4.12.403l3.083-1.792C6.574.586 5.692.332 4.91.332c-.567 0-1.08.133-1.522.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eiz879d2dgw",
    d: "M3.388.723L.303 2.515c1.053-.612 2.511-.526 4.12.403l3.083-1.792C6.574.586 5.692.332 4.91.332c-.567 0-1.08.133-1.522.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v1qeift0pgy",
    d: "M3.388.723L.303 2.515c1.053-.612 2.511-.526 4.12.403l3.083-1.792C6.574.586 5.692.332 4.91.332c-.567 0-1.08.133-1.522.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h785n9cv7gA",
    d: "M3.388.723L.303 2.515c1.053-.612 2.511-.526 4.12.403l3.083-1.792C6.574.586 5.692.332 4.91.332c-.567 0-1.08.133-1.522.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "5wj2z8lpwgC",
    d: "M3.388.723L.303 2.515c1.053-.612 2.511-.526 4.12.403l3.083-1.792C6.574.586 5.692.332 4.91.332c-.567 0-1.08.133-1.522.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7di3ldp4hgE",
    d: "M3.388.723L.303 2.515c1.053-.612 2.511-.526 4.12.403l3.083-1.792C6.574.586 5.692.332 4.91.332c-.567 0-1.08.133-1.522.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crif4d3a0gG",
    d: "M3.388.723L.303 2.515c1.053-.612 2.511-.526 4.12.403l3.083-1.792C6.574.586 5.692.332 4.91.332c-.567 0-1.08.133-1.522.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8771ofd2xgI",
    d: "M3.388.723L.303 2.515c1.053-.612 2.511-.526 4.12.403l3.083-1.792C6.574.586 5.692.332 4.91.332c-.567 0-1.08.133-1.522.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1l60gsdubgK",
    d: "M3.388.723L.303 2.515c1.053-.612 2.511-.526 4.12.403l3.083-1.792C6.574.586 5.692.332 4.91.332c-.567 0-1.08.133-1.522.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "xlw45puvfgM",
    d: "M3.388.723L.303 2.515c1.053-.612 2.511-.526 4.12.403l3.083-1.792C6.574.586 5.692.332 4.91.332c-.567 0-1.08.133-1.522.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fnkw3a7w0gO",
    d: "M3.388.723L.303 2.515c1.053-.612 2.511-.526 4.12.403l3.083-1.792C6.574.586 5.692.332 4.91.332c-.567 0-1.08.133-1.522.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x72v5165ogQ",
    d: "M3.388.723L.303 2.515c1.053-.612 2.511-.526 4.12.403l3.083-1.792C6.574.586 5.692.332 4.91.332c-.567 0-1.08.133-1.522.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bqdsxgllrgS",
    d: "M3.388.723L.303 2.515c1.053-.612 2.511-.526 4.12.403l3.083-1.792C6.574.586 5.692.332 4.91.332c-.567 0-1.08.133-1.522.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c0ok88v1kgU",
    d: "M3.388.723L.303 2.515c1.053-.612 2.511-.526 4.12.403l3.083-1.792C6.574.586 5.692.332 4.91.332c-.567 0-1.08.133-1.522.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "2yf1fvefugW",
    d: "M3.388.723L.303 2.515c1.053-.612 2.511-.526 4.12.403l3.083-1.792C6.574.586 5.692.332 4.91.332c-.567 0-1.08.133-1.522.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vv8i4bsa6gY",
    d: "M.05 1.995c.152.635.233 1.265.231 1.87-.002.604-.086 1.14-.24 1.598L3.125 3.67c.154-.458.238-.993.24-1.598.002-.604-.079-1.234-.23-1.869"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p59zyfti3ha",
    d: "M.05 1.995c.152.635.233 1.265.231 1.87-.002.604-.086 1.14-.24 1.598L3.125 3.67c.154-.458.238-.993.24-1.598.002-.604-.079-1.234-.23-1.869"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at8vcj4rzhc",
    d: "M.05 1.995c.152.635.233 1.265.231 1.87-.002.604-.086 1.14-.24 1.598L3.125 3.67c.154-.458.238-.993.24-1.598.002-.604-.079-1.234-.23-1.869"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a5aa74hhehe",
    d: "M.05 1.995c.152.635.233 1.265.231 1.87-.002.604-.086 1.14-.24 1.598L3.125 3.67c.154-.458.238-.993.24-1.598.002-.604-.079-1.234-.23-1.869"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nduw8vf7nhg",
    d: "M.05 1.995c.152.635.233 1.265.231 1.87-.002.604-.086 1.14-.24 1.598L3.125 3.67c.154-.458.238-.993.24-1.598.002-.604-.079-1.234-.23-1.869"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kn9o2u55khi",
    d: "M.05 1.995c.152.635.233 1.265.231 1.87-.002.604-.086 1.14-.24 1.598L3.125 3.67c.154-.458.238-.993.24-1.598.002-.604-.079-1.234-.23-1.869"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wx8p03oxihk",
    d: "M.05 1.995c.152.635.233 1.265.231 1.87-.002.604-.086 1.14-.24 1.598L3.125 3.67c.154-.458.238-.993.24-1.598.002-.604-.079-1.234-.23-1.869"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z7dor4s9ohm",
    d: "M.05 1.995c.152.635.233 1.265.231 1.87-.002.604-.086 1.14-.24 1.598L3.125 3.67c.154-.458.238-.993.24-1.598.002-.604-.079-1.234-.23-1.869"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8zwa997e1ho",
    d: "M.05 1.995c.152.635.233 1.265.231 1.87-.002.604-.086 1.14-.24 1.598L3.125 3.67c.154-.458.238-.993.24-1.598.002-.604-.079-1.234-.23-1.869"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b4pbmzib8hq",
    d: "M.05 1.995c.152.635.233 1.265.231 1.87-.002.604-.086 1.14-.24 1.598L3.125 3.67c.154-.458.238-.993.24-1.598.002-.604-.079-1.234-.23-1.869"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4vb97jdhghs",
    d: "M.05 1.995c.152.635.233 1.265.231 1.87-.002.604-.086 1.14-.24 1.598L3.125 3.67c.154-.458.238-.993.24-1.598.002-.604-.079-1.234-.23-1.869"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q941m2vabhu",
    d: "M.05 1.995c.152.635.233 1.265.231 1.87-.002.604-.086 1.14-.24 1.598L3.125 3.67c.154-.458.238-.993.24-1.598.002-.604-.079-1.234-.23-1.869"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mlgj0odprhw",
    d: "M.05 1.995c.152.635.233 1.265.231 1.87-.002.604-.086 1.14-.24 1.598L3.125 3.67c.154-.458.238-.993.24-1.598.002-.604-.079-1.234-.23-1.869"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z94q0ln3hhy",
    d: "M.05 1.995c.152.635.233 1.265.231 1.87-.002.604-.086 1.14-.24 1.598L3.125 3.67c.154-.458.238-.993.24-1.598.002-.604-.079-1.234-.23-1.869"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6hpllgm3khA",
    d: "M.05 1.995c.152.635.233 1.265.231 1.87-.002.604-.086 1.14-.24 1.598L3.125 3.67c.154-.458.238-.993.24-1.598.002-.604-.079-1.234-.23-1.869"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6fu5ctmn0hC",
    d: "M.393 2.023l.054.051.025.024.095.093.033.034.074.074.026.028L3.785.534 3.758.507 3.685.433 3.65.398C3.62.367 3.588.336 3.556.306L3.532.28l-.055-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "5121w545thE",
    d: "M.393 2.023l.054.051.025.024.095.093.033.034.074.074.026.028L3.785.534 3.758.507 3.685.433 3.65.398C3.62.367 3.588.336 3.556.306L3.532.28l-.055-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1tbt1yj3whG",
    d: "M.393 2.023l.054.051.025.024.095.093.033.034.074.074.026.028L3.785.534 3.758.507 3.685.433 3.65.398C3.62.367 3.588.336 3.556.306L3.532.28l-.055-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "qsgcclxa7hI",
    d: "M.393 2.023l.054.051.025.024.095.093.033.034.074.074.026.028L3.785.534 3.758.507 3.685.433 3.65.398C3.62.367 3.588.336 3.556.306L3.532.28l-.055-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k5fdkewuchK",
    d: "M.393 2.023l.054.051.025.024.095.093.033.034.074.074.026.028L3.785.534 3.758.507 3.685.433 3.65.398C3.62.367 3.588.336 3.556.306L3.532.28l-.055-.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "iv9a9hhcshM",
    d: "M.202 1.828c1.26 1.305 2.261 3.04 2.757 4.779l3.085-1.793C5.548 3.076 4.546 1.34 3.286.036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "13k8k2n3whO",
    d: "M.202 1.828c1.26 1.305 2.261 3.04 2.757 4.779l3.085-1.793C5.548 3.076 4.546 1.34 3.286.036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d3bioa6clhQ",
    d: "M.202 1.828c1.26 1.305 2.261 3.04 2.757 4.779l3.085-1.793C5.548 3.076 4.546 1.34 3.286.036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rbiyj2vxhhS",
    d: "M.202 1.828c1.26 1.305 2.261 3.04 2.757 4.779l3.085-1.793C5.548 3.076 4.546 1.34 3.286.036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "almz2klw6hU",
    d: "M.202 1.828c1.26 1.305 2.261 3.04 2.757 4.779l3.085-1.793C5.548 3.076 4.546 1.34 3.286.036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h86zbuh8chW",
    d: "M.202 1.828c1.26 1.305 2.261 3.04 2.757 4.779l3.085-1.793C5.548 3.076 4.546 1.34 3.286.036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9bpxka83ohY",
    d: "M.202 1.828c1.26 1.305 2.261 3.04 2.757 4.779l3.085-1.793C5.548 3.076 4.546 1.34 3.286.036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "besuuojsria",
    d: "M.202 1.828c1.26 1.305 2.261 3.04 2.757 4.779l3.085-1.793C5.548 3.076 4.546 1.34 3.286.036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "628ozc73iic",
    d: "M.202 1.828c1.26 1.305 2.261 3.04 2.757 4.779l3.085-1.793C5.548 3.076 4.546 1.34 3.286.036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4zgwsqixsie",
    d: "M.202 1.828c1.26 1.305 2.261 3.04 2.757 4.779l3.085-1.793C5.548 3.076 4.546 1.34 3.286.036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tcm43ur1big",
    d: "M.202 1.828c1.26 1.305 2.261 3.04 2.757 4.779l3.085-1.793C5.548 3.076 4.546 1.34 3.286.036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "saezx2ikxii",
    d: "M.202 1.828c1.26 1.305 2.261 3.04 2.757 4.779l3.085-1.793C5.548 3.076 4.546 1.34 3.286.036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nhyzudl7fik",
    d: "M.202 1.828c1.26 1.305 2.261 3.04 2.757 4.779l3.085-1.793C5.548 3.076 4.546 1.34 3.286.036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wal3ve91uim",
    d: "M.202 1.828c1.26 1.305 2.261 3.04 2.757 4.779l3.085-1.793C5.548 3.076 4.546 1.34 3.286.036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "yh71e94uhio",
    d: "M.202 1.828c1.26 1.305 2.261 3.04 2.757 4.779l3.085-1.793C5.548 3.076 4.546 1.34 3.286.036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "zqci6fjytiq",
    d: "M.202 1.828c1.26 1.305 2.261 3.04 2.757 4.779l3.085-1.793C5.548 3.076 4.546 1.34 3.286.036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e2aw4egw0is",
    d: "M.202 1.828c1.26 1.305 2.261 3.04 2.757 4.779l3.085-1.793C5.548 3.076 4.546 1.34 3.286.036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "gc3kyhkvgiu",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6b4uf7496iw",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aupan20x7iy",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0nbvv7pv1iA",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "qv96tz919iC",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uvim4gs4siE",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f6jn37rugiG",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "yc8i52p3piI",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wqgl4r1dliK",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ch3bx1braiM",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0nla0qm5uiO",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "2avkcyb3hiQ",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6fytnp5g1iS",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eg8sngsygiU",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "yiiwyvfywiW",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6h6gbm54uiY",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fci04uljuja",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "2odantpaqjc",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9121ssbf6je",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "78ebwmoqijg",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9bowd7c1iji",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ed5el1fkojk",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vhwh31vqbjm",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "27k4zebezjo",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "2pc8how92jq",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crxbgrzk7js",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "le04zlrj6ju",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7xop7zl7bjw",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7ememxwgbjy",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y4mx75xwejA",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "76g038vz7jC",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ge28rncgajE",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "zsvwf9psqjG",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "352e4qmdgjI",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fhw1vxyuxjK",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0inkol3cljM",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "58wmheiixjO",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nvoyg50shjQ",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "us60wq3psjS",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f6i6arzozjU",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h5azijsnvjW",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ysoz5dgarjY",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9bobmhp6kka",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1zo4ilzvpkc",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eft0auexzke",
    d: "M.397 1.911C3.596 3.758 6.18 8.234 6.17 11.907c-.005 1.826-.65 3.11-1.689 3.716l3.084-1.793c1.04-.604 1.684-1.888 1.69-3.715C9.264 6.442 6.68 1.966 3.48.12"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M0 0H80V80H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M0 79.869L79.869 79.869 79.869 0 0 0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#123155",
    d: "M54.721 16.709L36.91 6.425c-3-1.732-7.535-1.92-10.133-.42L8.531 16.538.015 18.556v4.265c-.007.095-.005.191 0 .287v.066h.003c.084 1.094.914 2.23 2.467 3.125l23.368 13.492c3 1.731 7.536 1.92 10.133.42l2.645-1.527 22.374-12.918c1.225-.706 1.79-1.664 1.742-2.658h.008v-4.321l-8.034-2.078z",
    transform: "translate(8.553 30.058)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9E8E7",
    d: "M61.005 21.214L35.985 35.66c-2.597 1.498-7.133 1.31-10.132-.421L2.486 21.749c-3-1.733-3.326-4.352-.728-5.851L26.776 1.453c2.598-1.5 7.133-1.312 10.133.42l23.368 13.491c3 1.731 3.325 4.35.728 5.85",
    transform: "translate(8.553 30.058)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0061B2",
    d: "M14.23 23.189L21.345 27.297 28.459 23.19 21.345 19.082zM0 14.974L7.115 19.082 14.23 14.974 7.115 10.867z",
    transform: "translate(28 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9E8E7",
    d: "M7.115 19.082L0 14.974 0 33.645 21.345 45.969 21.345 27.297 14.23 23.189 14.23 17.215 7.115 13.107z",
    transform: "translate(28 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C2",
    d: "M21.345 27.297L21.345 45.969 28.46 41.861 28.46 23.19z",
    transform: "translate(28 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#033158",
    d: "M0 35.388L21.402 48.438 21.411 45.164 0.009 32.113z",
    transform: "translate(28 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0061B2",
    d: "M21.309 45.13L21.3 48.404 28.406 44.275 28.416 41zM14.23 17.215L7.115 13.107 14.23 8.999 21.345 13.107z",
    transform: "translate(28 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C2",
    d: "M14.23 17.215L21.345 13.107 21.345 19.082 14.23 23.19z",
    transform: "translate(28 8)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#033158",
    d: "M10.672 16.655c.965.556 1.747 1.91 1.747 3.024s-.782 1.565-1.747 1.009c-.964-.557-1.746-1.912-1.746-3.025 0-1.114.782-1.565 1.746-1.008M20.051 29.288L18.757 28.541 18.757 32.276 20.051 33.022zM17.464 27.795L16.17 27.048 16.17 30.782 17.464 31.529zM5.175 20.699L3.881 19.952 3.881 23.687 5.175 24.434zM2.587 19.206L1.294 18.459 1.294 22.193 2.588 22.94z",
    transform: "translate(28 8) translate(0 .146)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C2",
    d: "M10.672 6.05v6.753c0 .525.348 1.05 1.042 1.452 1.39.802 3.642.802 5.031 0 .695-.401 1.042-.927 1.042-1.452V6.05h-7.115z",
    transform: "translate(28 8) translate(0 .146)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0061B2",
    d: "M17.787 6.05s-.766 1.22-3.557 1.22-3.558-1.22-3.558-1.22c0-1.965 1.593-3.558 3.558-3.558 1.965 0 3.557 1.593 3.557 3.558",
    transform: "translate(28 8) translate(0 .146)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#033158",
    d: "M13.346.915v1.963c0 .131.086.262.259.361.345.2.905.2 1.25 0 .173-.1.259-.23.259-.36V.914h-1.768z",
    transform: "translate(28 8) translate(0 .146)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 8) translate(0 .146) translate(13.27)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "po305a3wab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2p7re3xta"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0061B2",
    d: "M1.845.915s-.19.244-.884.244S.076.915.076.915c0-.488.396-.884.885-.884.488 0 .884.396.884.884",
    mask: "url(#po305a3wab)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#033158",
    d: "M13.906 8.629v4.654c.215.013.432.013.647 0V8.629c-.104.004-.213.006-.324.006-.11 0-.218-.002-.323-.006M15.287 13.21c.222-.034.44-.082.646-.145V8.492c-.194.037-.408.067-.646.088v4.63zM12.527 13.064c.207.064.424.112.645.147V8.58c-.237-.021-.451-.051-.645-.088v4.572zM11.306 12.395c.112.099.244.192.394.28.08.046.165.089.252.129V8.3c-.27-.077-.482-.165-.646-.25v4.345zM16.507 12.804c.087-.04.172-.083.253-.13.15-.087.282-.18.394-.28V8.05c-.164.084-.377.172-.647.25v4.504zM14.23 23.044L14.23 23.461 21.345 27.578 21.345 27.151zM7.115 12.961L7.115 13.379 14.23 17.495 14.23 17.069zM0 14.828L0 15.246 7.115 19.363 7.115 18.936zM28.46 23.044L28.46 23.461 21.345 27.578 21.345 27.151zM21.345 12.961L21.345 13.379 14.23 17.495 14.23 17.069z",
    transform: "translate(28 8) translate(0 .146)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(7.044 7.082)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sqdsucdxpd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8fr16rc56c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BFC1C3",
    fillRule: "nonzero",
    d: "M.124 2.186L3.208.393V.41c0 .087 0 .174.003.261L.127 2.464l-.003-.262v-.016",
    mask: "url(#sqdsucdxpd)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "m434nvw1qf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#biczepzmye"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C4C5C7",
    fillRule: "nonzero",
    d: "M.127 2.464L3.211.67c.003.093.008.187.013.28L.14 2.744c-.006-.094-.01-.187-.013-.28",
    mask: "url(#m434nvw1qf)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "sc1648r65h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v45odou3og"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C8C9CB",
    fillRule: "nonzero",
    d: "M.14 2.744L3.225.95c.006.094.013.188.022.282L.162 3.026C.153 2.93.146 2.837.14 2.744",
    mask: "url(#sc1648r65h)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "n531fewglj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#067qp8np4i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCECF",
    fillRule: "nonzero",
    d: "M.163 3.025l3.084-1.792c.009.094.02.189.032.284L.194 3.309c-.012-.095-.022-.19-.031-.284",
    mask: "url(#n531fewglj)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "dv6i4va86l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kikzncq5zk"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D2D3",
    fillRule: "nonzero",
    d: "M.194 3.31l3.084-1.793c.013.097.027.193.042.29L.236 3.6c-.016-.097-.03-.194-.042-.29",
    mask: "url(#dv6i4va86l)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "0bpsxdj04n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dliaudi93m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D6D7",
    fillRule: "nonzero",
    d: "M.236 3.6L3.32 1.807c.015.098.032.196.05.294L.286 3.893C.268 3.795.251 3.697.236 3.6",
    mask: "url(#0bpsxdj04n)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "5mwc705h0p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5a9f6046eo"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D9DADB",
    fillRule: "nonzero",
    d: "M.286 3.893L3.371 2.1c.018.102.039.202.06.303L.349 4.195c-.023-.1-.043-.201-.062-.302",
    mask: "url(#5mwc705h0p)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "tuvk0ph1rr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#scpm5mif1q"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DDDEDF",
    fillRule: "nonzero",
    d: "M.348 4.195l3.084-1.792c.022.101.046.202.07.303L.42 4.5c-.026-.102-.05-.203-.071-.304",
    mask: "url(#tuvk0ph1rr)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "0xzex4lbst",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x1sxyo4vas"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E1E2E3",
    fillRule: "nonzero",
    d: "M.418 4.499l3.085-1.793c.025.103.052.205.08.308L.5 4.806C.47 4.704.444 4.6.419 4.499",
    mask: "url(#0xzex4lbst)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "atymhr5ysv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2v4x5iebju"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E6E7",
    fillRule: "nonzero",
    d: "M.499 4.806l3.084-1.793c.029.103.059.205.09.307L.589 5.112c-.032-.102-.061-.204-.09-.306",
    mask: "url(#atymhr5ysv)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "cdorr781nx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g25y5k79hw"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEB",
    fillRule: "nonzero",
    d: "M.588 5.112L3.673 3.32c.03.1.062.2.096.3L.685 5.41c-.034-.1-.066-.2-.097-.299",
    mask: "url(#cdorr781nx)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ay6dr4l1cz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s5efoyxvty"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EEEEEF",
    fillRule: "nonzero",
    d: "M.684 5.411L3.77 3.62c.032.099.067.197.102.295L.787 5.707C.752 5.609.717 5.51.684 5.41",
    mask: "url(#ay6dr4l1cz)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "cfgp4cpl5B",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2gqfk4clA"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F3F3",
    fillRule: "nonzero",
    d: "M.787 5.707l3.084-1.793c.035.095.07.19.107.284L.894 5.99C.857 5.896.82 5.8.787 5.707",
    mask: "url(#cfgp4cpl5B)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "rfjpglrkxD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7t4c60t4rC"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    fillRule: "nonzero",
    d: "M.894 5.99l3.084-1.793c.037.095.075.19.113.282L1.007 6.272C.968 6.178.931 6.084.894 5.99",
    mask: "url(#rfjpglrkxD)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "toza1fqgdF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gxa3wvbbdE"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M1.007 6.272l3.084-1.793c.04.093.078.186.12.277L1.125 6.55c-.041-.092-.08-.184-.119-.277",
    mask: "url(#toza1fqgdF)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "j30pehhemH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i2e54q6z8G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M1.126 6.549L4.21 4.756c.042.094.084.188.128.28L1.254 6.83c-.044-.093-.086-.187-.128-.281",
    mask: "url(#j30pehhemH)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "99scnh0jdJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hy5olnes3I"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M1.254 6.83l3.084-1.793c.048.102.097.203.147.304L1.4 7.133c-.05-.1-.1-.202-.147-.304",
    mask: "url(#99scnh0jdJ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "4lvaa5jf7L",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#945pdl7gwK"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M1.4 7.134L4.486 5.34c.058.117.118.232.18.347L1.58 7.48c-.061-.115-.121-.23-.18-.346",
    mask: "url(#4lvaa5jf7L)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "jskyc8crmN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#43cxhvu0mM"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M1.58 7.48l3.084-1.792c.092.171.187.341.286.51L1.866 7.99c-.099-.168-.194-.338-.286-.51",
    mask: "url(#jskyc8crmN)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "kkdk26tb0P",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7py8mb32aO"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M1.866 7.99L4.95 6.197c.136.232.28.46.429.684L2.294 8.673c-.149-.223-.292-.451-.428-.683",
    mask: "url(#kkdk26tb0P)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "qnv9g43umR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s9ced5zp3Q"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M2.294 8.673L5.38 6.88c.119.179.242.354.368.525L2.663 9.198c-.127-.172-.25-.347-.369-.525",
    mask: "url(#qnv9g43umR)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "weujbps53T",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u8e9gtrrtS"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M2.663 9.198l3.084-1.793c.084.115.17.227.258.338L2.92 9.536c-.087-.111-.173-.224-.257-.338",
    mask: "url(#weujbps53T)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "h8hugwxv4V",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reauaknr6U"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M2.92 9.536l3.085-1.793c.073.093.147.185.222.275L3.142 9.81c-.075-.09-.149-.181-.222-.274",
    mask: "url(#h8hugwxv4V)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "iafuplmrxX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pyv5ipvkkW"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M3.142 9.81l3.085-1.792c.073.088.148.175.223.26l-3.085 1.794c-.075-.086-.15-.174-.223-.262",
    mask: "url(#iafuplmrxX)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "hypnse189Z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n4nl8n067Y"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M3.366 10.071L6.45 8.28c.074.084.15.168.225.25L3.591 10.32c-.076-.082-.152-.165-.225-.25",
    mask: "url(#hypnse189Z)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "tp0recxo9ab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#agd9v1y34aa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    fillRule: "nonzero",
    d: "M3.59 10.32l3.085-1.792c.078.085.157.168.237.25l-3.084 1.791c-.08-.081-.16-.164-.237-.248",
    mask: "url(#tp0recxo9ab)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "64cz1pgohad",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ak3tkqxlkac"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F3F3",
    fillRule: "nonzero",
    d: "M3.828 10.57l3.084-1.793c.08.082.162.162.244.241l-3.084 1.793c-.082-.08-.164-.16-.244-.241",
    mask: "url(#64cz1pgohad)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "eiobitlfeaf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v03uzr850ae"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EEEEEF",
    fillRule: "nonzero",
    d: "M4.072 10.81l3.084-1.792c.084.081.169.16.255.237l-3.085 1.792c-.086-.077-.17-.156-.254-.236",
    mask: "url(#eiobitlfeaf)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "rya9ls8u3ah",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tqj1axoghag"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEB",
    fillRule: "nonzero",
    d: "M4.326 11.047l3.085-1.792c.085.076.17.151.257.224l-3.085 1.793c-.086-.073-.172-.148-.257-.225",
    mask: "url(#rya9ls8u3ah)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "1eya5wm1daj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l9tjyvm10ai"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E6E7",
    fillRule: "nonzero",
    d: "M4.584 11.272l3.084-1.793c.085.072.17.142.257.21l-3.084 1.793c-.086-.068-.172-.138-.257-.21",
    mask: "url(#1eya5wm1daj)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "ob5ojye6tal",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5pt1rxnrqak"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E1E2E3",
    fillRule: "nonzero",
    d: "M4.841 11.482l3.084-1.793c.084.067.169.132.254.194l-3.084 1.793c-.085-.063-.17-.128-.254-.194",
    mask: "url(#ob5ojye6tal)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "yys29pokian",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7h3sap5x6am"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DDDEDF",
    fillRule: "nonzero",
    d: "M5.095 11.676l3.084-1.793c.084.062.167.121.252.179l-3.085 1.792c-.084-.058-.168-.117-.251-.178",
    mask: "url(#yys29pokian)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "0v6tnb4pnap",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pmw2pnks6ao"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D9DADB",
    fillRule: "nonzero",
    d: "M5.346 11.854l3.085-1.792c.081.056.163.11.246.163l-3.085 1.792c-.082-.052-.164-.107-.246-.163",
    mask: "url(#0v6tnb4pnap)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "k6zue6ah8ar",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3bwr7fyu8aq"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D6D7",
    fillRule: "nonzero",
    d: "M5.592 12.017l3.084-1.793c.082.052.163.102.245.15l-3.084 1.793c-.082-.049-.163-.098-.245-.15",
    mask: "url(#k6zue6ah8ar)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "6526n0nwiat",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6mi565t86as"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D2D3",
    fillRule: "nonzero",
    d: "M5.837 12.167l3.084-1.793.057.033L5.894 12.2c-.02-.01-.038-.022-.057-.033",
    mask: "url(#6526n0nwiat)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(9.057 12.616)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qoii4rzceav",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1fyccr5ozau"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#72A1D2",
    fillRule: "nonzero",
    d: "M.207 1.657L3.29-.136c.078.147.16.292.244.434L.45 2.091c-.084-.143-.165-.288-.243-.434",
    mask: "url(#qoii4rzceav)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillRule: "nonzero",
    d: "M14.062 14.902c-.017-.017-.032-.036-.049-.054-.128-.14-.253-.284-.375-.432l-.04-.05c-.119-.146-.234-.296-.347-.45-.031-.042-.06-.087-.092-.13-.082-.115-.162-.231-.24-.35-.074-.11-.143-.224-.213-.339-.048-.077-.098-.155-.143-.234-.027-.045-.052-.091-.078-.137-.078-.14-.154-.278-.227-.419l-.034-.066c-.091-.18-.178-.362-.26-.545 0-.001 0-.003-.002-.005-.081-.185-.157-.371-.229-.558l-.018-.05c-.067-.178-.129-.357-.185-.537l-.027-.084-3.085 1.793.019.058.008.027.055.17c.028.084.058.168.088.251.013.038.029.076.043.114l.019.05.029.078.096.24c.033.078.066.157.101.235l.002.005.003.005c.033.077.068.153.103.229.042.086.083.173.127.26l.03.057.032.064.09.175c.044.082.092.163.137.244.02.034.037.07.056.102h.002v.001h-.002l.023.037.028.05c.036.061.077.12.114.182.07.114.14.229.214.34.013.02.024.041.038.061.065.098.134.192.202.288.03.044.06.088.092.131l.018.026c.072.098.145.194.22.289l.109.134.04.05.04.05c.064.076.127.15.192.224l.143.159.018.02.03.034 3.085-1.793z",
    transform: "translate(21 32)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(11.07 14.629)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rpyj4b9pyax",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nlbgoogz3aw"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1D396B",
    fillRule: "nonzero",
    d: "M.054 2.219L3.138.426l.003.004L.057 2.223l-.003-.004",
    mask: "url(#rpyj4b9pyax)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(11.07 14.629)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rmvywevvhaz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#80rbyjcumay"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1D396B",
    fillRule: "nonzero",
    d: "M.057 2.222L3.141.43l.028.027L.084 2.25l-.027-.028",
    mask: "url(#rmvywevvhaz)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(11.07 14.629)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6j1bxe2f0aB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8jr301ofeaA"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1D396B",
    fillRule: "nonzero",
    d: "M.084 2.25L3.168.457c.008.01.017.018.026.026L.109 2.276.084 2.25",
    mask: "url(#6j1bxe2f0aB)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "1q20f0um3aD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nrb4dhwaeaC"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C3869",
    fillRule: "nonzero",
    d: "M.11 2.276L3.192.483 3.24.53.156 2.323l-.047-.047",
    mask: "url(#1q20f0um3aD)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillRule: "nonzero",
    d: "M14.03 14.868c.105.113.21.223.318.33l-3.085 1.793c-.107-.107-.213-.218-.317-.33l3.085-1.793",
    transform: "translate(21 32)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(10.566 14.629)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rmebilp2faF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#60igle3ikaE"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillRule: "nonzero",
    d: "M.22 1.853L3.304.06c.063.073.127.144.192.213L.412 2.066c-.065-.07-.129-.141-.192-.213",
    mask: "url(#rmebilp2faF)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "3jblb9xenaH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vb9l70e5caG"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillRule: "nonzero",
    d: "M.412 2.066L3.496.273c.066.072.134.143.202.212L.614 2.278c-.068-.07-.136-.14-.202-.212",
    mask: "url(#3jblb9xenaH)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "a0jw6ar2eaJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wk68to9djaI"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillRule: "nonzero",
    d: "M.614 2.277L3.698.485c.068.07.138.139.208.206L.822 2.483c-.07-.067-.14-.136-.208-.206",
    mask: "url(#a0jw6ar2eaJ)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#082049",
    fillRule: "nonzero",
    d: "M11.123 16.848l.003.003-.003-.003",
    transform: "translate(21 32)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(8.05 10.1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9dzc583zraL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k8tkrxveeaK"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1B3565",
    fillRule: "nonzero",
    d: "M.311 1.962L3.396.169l.001.005L.313 1.967.31 1.962",
    mask: "url(#9dzc583zraL)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(8.05 10.1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hpp2xg527aN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#syh00fh2jaM"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1B3565",
    fillRule: "nonzero",
    d: "M.302 1.928L3.386.135l.01.034L.31 1.961l-.01-.033",
    mask: "url(#hpp2xg527aN)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(8.05 10.1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "uh90m0epkaP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#014l6olk9aO"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A3464",
    fillRule: "nonzero",
    d: "M.273 1.824L3.357.032l.02.07L.292 1.895l-.019-.07",
    mask: "url(#uh90m0epkaP)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "k0g3v7wk4aR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i5bj1ojjlaQ"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1B3565",
    fillRule: "nonzero",
    d: "M.292 1.895L3.377.102l.009.033L.302 1.927l-.01-.032",
    mask: "url(#k0g3v7wk4aR)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(8.05 9.597)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fnqq4wgivaT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lzk1csyroaS"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A3464",
    fillRule: "nonzero",
    d: "M.261 2.282L3.345.489l.013.046L.273 2.328l-.012-.046",
    mask: "url(#fnqq4wgivaT)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillRule: "nonzero",
    d: "M11.394 10.082c.039.146.081.293.127.439l-3.084 1.792c-.046-.146-.088-.292-.127-.438l3.084-1.793",
    transform: "translate(21 32)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(8.05 9.597)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lvnjiwnyhaV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0q9ol97kkaU"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillRule: "nonzero",
    d: "M.223 2.135L3.307.342c.022.087.045.175.07.262L.291 2.397C.268 2.31.245 2.222.223 2.135",
    mask: "url(#lvnjiwnyhaV)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "4bczg45vdaX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9ux5kfbjyaW"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillRule: "nonzero",
    d: "M.292 2.396L3.376.604c.024.087.05.174.076.26L.368 2.659C.342 2.57.316 2.483.292 2.396",
    mask: "url(#4bczg45vdaX)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "vtrpkumpzaZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#42cy6w5rfaY"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillRule: "nonzero",
    d: "M.368 2.657L3.452.865c.026.085.054.17.082.255L.45 2.912c-.029-.085-.056-.17-.082-.255",
    mask: "url(#vtrpkumpzaZ)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(8.05 9.597)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "yix3368oqbb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gbwu9y3szba"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A3464",
    fillRule: "nonzero",
    d: "M.229 2.156L3.313.363c.01.042.02.084.033.126L.26 2.282.23 2.156",
    mask: "url(#yix3368oqbb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(8.05 9.597)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5ojw6t4ozbd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#685akt1eabc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#193363",
    fillRule: "nonzero",
    d: "M.22 2.121L3.304.33l.008.031L.228 2.152l-.008-.03",
    mask: "url(#5ojw6t4ozbd)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "fbc0tbun0bf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u6r63rp7mbe"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A3464",
    fillRule: "nonzero",
    d: "M0.228 2.153L3.312 0.36 3.313 0.363 0.228 2.156z",
    mask: "url(#fbc0tbun0bf)"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    d: "M5.681 1.613l-.03-.02c-.132-.09-.263-.186-.393-.287l-.033-.025c-.126-.099-.25-.203-.373-.31L4.803.928c-.12-.106-.236-.217-.352-.33L4.338.484 1.253 2.277l.085.084.03.029c.03.03.061.062.094.093.071.069.143.136.217.202l.04.035.05.043.128.113.22.18.023.017.034.025c.053.042.106.082.16.122.07.053.142.103.214.153l.02.013.03.02.16.105c.069.044.138.087.208.128l.048.028L6.1 1.875c-.141-.082-.28-.17-.418-.262",
    transform: "translate(21 32) translate(9.926 14.629)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082049",
    d: "M1.506 2.526l-.05-.049.05.049",
    transform: "translate(21 32) translate(9.926 14.629)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(8.05 9.597)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6b2vbje6sbh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pijb290rrbg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#193363",
    fillRule: "nonzero",
    d: "M.203 2.05L3.287.257l.018.072L.22 2.12.203 2.05",
    mask: "url(#6b2vbje6sbh)"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A8A8A8",
    d: "M3.889 8.363L6.973 6.571 6.97 7.777 3.885 9.569z",
    transform: "translate(21 32) translate(7.547 7.585)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    d: "M3.88 2.617c-.015-.051-.027-.102-.041-.153-.04-.156-.077-.312-.109-.467l-.012-.062c-.031-.157-.059-.313-.08-.468L3.63 1.41c-.022-.158-.039-.315-.05-.471L3.577.899C3.565.73 3.559.565 3.56.4V.386L.475 2.18v.013l.003.223c.003.08.007.159.012.238 0 .013.002.025.003.037 0 .015.002.028.003.042l.013.161c.007.08.016.16.026.242l.01.07.008.054.018.123c.013.083.027.166.043.25l.019.094.013.063.02.1.06.258.03.11.007.032c.011.04.02.08.032.12l3.084-1.792z",
    transform: "translate(21 32) translate(7.547 7.585)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3C3C3",
    d: "M0.706 4.062L3.79 2.269 4.843 2.878 1.758 4.67z",
    transform: "translate(21 32) translate(7.547 7.585)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C6D6D",
    d: "M3.579 7.969L6.664 6.177 7.456 6.158 4.371 7.951zM2.361 4.468L5.445 2.675 5.029 3.342 1.945 5.134z",
    transform: "translate(21 32) translate(7.547 7.585)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(7.044 3.56)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3o54i0jembj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k0cirrvqpbi"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#96999B",
    fillRule: "nonzero",
    d: "M1.813 2.012L4.897.219c-.397.23-.736.56-1.003.98L.809 2.991c.269-.42.607-.749 1.004-.98",
    mask: "url(#3o54i0jembj)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "bvkhi6sh0bl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v73wxqv8ubk"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9A9C9F",
    fillRule: "nonzero",
    d: "M.81 2.991L3.893 1.2c-.08.125-.152.256-.219.396L.591 3.387c.066-.139.14-.271.218-.396",
    mask: "url(#bvkhi6sh0bl)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "vxxixxxqmbn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xt3dr7o22bm"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9EA0A3",
    fillRule: "nonzero",
    d: "M.59 3.387l3.085-1.792c-.05.105-.096.215-.139.33L.452 3.716c.043-.114.09-.224.139-.33",
    mask: "url(#vxxixxxqmbn)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "uyzq0mxi1bp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8mecr61i2bo"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A2A4A7",
    fillRule: "nonzero",
    d: "M.452 3.717l3.084-1.793c-.036.099-.07.2-.1.305L.35 4.02c.03-.105.064-.206.101-.304",
    mask: "url(#uyzq0mxi1bp)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "zq3jvgm71br",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m8776abz3bq"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A6A8AB",
    fillRule: "nonzero",
    d: "M.351 4.021L3.435 2.23c-.028.096-.053.194-.077.295L.274 4.317c.023-.101.049-.2.077-.296",
    mask: "url(#zq3jvgm71br)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "ff1awxu1gbt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ka1jpn0vzbs"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AAADAF",
    fillRule: "nonzero",
    d: "M.274 4.317l3.084-1.793c-.02.093-.04.187-.057.284L.217 4.6c.017-.097.036-.19.057-.283",
    mask: "url(#ff1awxu1gbt)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "xsrt2m2g0bv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6791wmo60bu"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AFB1B3",
    fillRule: "nonzero",
    d: "M.217 4.6l3.084-1.793c-.015.091-.03.183-.04.277L.175 4.876c.012-.094.026-.185.041-.276",
    mask: "url(#xsrt2m2g0bv)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "qpc9ry5ddbx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#inlhymy3qbw"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B5B7",
    fillRule: "nonzero",
    d: "M.176 4.876L3.26 3.084c-.011.091-.02.184-.028.278L.147 5.155c.008-.095.017-.187.029-.279",
    mask: "url(#qpc9ry5ddbx)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "ead6krvp5bz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#abaaemxsmby"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B7B9BB",
    fillRule: "nonzero",
    d: "M.147 5.155l3.084-1.793c-.007.09-.013.181-.016.273L.13 5.428c.004-.093.01-.184.017-.273",
    mask: "url(#ead6krvp5bz)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "df5litv6nbB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d539maajfbA"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    fillRule: "nonzero",
    d: "M.13 5.428l3.085-1.793c-.004.092-.006.185-.007.28L.124 5.708c0-.095.002-.188.006-.28",
    mask: "url(#df5litv6nbB)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "yyxbzrzzbbD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aeew5f0ncbC"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BFC1C3",
    fillRule: "nonzero",
    d: "M.124 5.708l3.084-1.793v.017c0 .087 0 .174.003.261L.127 5.986l-.003-.262v-.016",
    mask: "url(#yyxbzrzzbbD)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillRule: "nonzero",
    d: "M11.125 7.53c.01-.123.024-.243.04-.36l.01-.07c.019-.115.04-.229.066-.337l.016-.06c.027-.109.056-.215.09-.316l.038-.107L8.301 8.07l-.038.109c-.018.05-.033.101-.049.154-.015.052-.028.106-.041.16-.006.02-.012.04-.016.061l-.007.027c-.018.079-.034.159-.048.24l-.01.071c-.005.023-.008.046-.011.069l-.015.097c-.01.076-.017.155-.023.234l-.002.03-.003.044-.01.16c-.003.078-.005.156-.005.236v.015c0 .073 0 .147.003.222l3.084-1.792c-.003-.075-.004-.15-.003-.223 0-.14.006-.276.015-.41l.003-.045",
    transform: "translate(21 32)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(12.579 17.145)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j2pc2afz7bF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1ut4sy8jnbE"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D2D3",
    fillRule: "nonzero",
    d: "M.36 2.137L3.442.344l.185.104L.543 2.24c-.06-.033-.122-.067-.184-.103",
    mask: "url(#j2pc2afz7bF)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "3fyf7a5ylbH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kcq1go0fybG"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCECF",
    fillRule: "nonzero",
    d: "M.543 2.24L3.628.447c.08.044.158.084.237.124L.781 2.363c-.079-.039-.158-.08-.238-.123",
    mask: "url(#3fyf7a5ylbH)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "6eu453bu7bJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#olq8bomqrbI"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C8C9CB",
    fillRule: "nonzero",
    d: "M.78 2.363L3.866.57c.08.04.157.076.235.111L1.015 2.474C.938 2.438.86 2.402.781 2.363",
    mask: "url(#6eu453bu7bJ)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "rsykl4oknbL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oh1kvricmbK"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C4C5C7",
    fillRule: "nonzero",
    d: "M1.015 2.474L4.1.68c.078.035.155.068.232.098L1.247 2.572c-.077-.03-.154-.064-.232-.098",
    mask: "url(#rsykl4oknbL)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "j6phifq2wbN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4qtdjlmambM"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BFC1C3",
    fillRule: "nonzero",
    d: "M1.247 2.572L4.332.779c.078.032.156.062.234.088L1.48 2.66c-.077-.027-.155-.057-.234-.088",
    mask: "url(#j6phifq2wbN)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "e5dw0e8glbP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sze0msbdabO"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    fillRule: "nonzero",
    d: "M1.481 2.66L4.565.867c.078.028.155.053.232.077L1.713 2.736c-.077-.024-.154-.049-.232-.076",
    mask: "url(#e5dw0e8glbP)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "5h3z15zrpbR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t8xvzrn5wbQ"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B7B9BB",
    fillRule: "nonzero",
    d: "M1.713 2.736L4.797.943c.08.024.16.047.24.066L1.953 2.802c-.08-.02-.16-.042-.24-.066",
    mask: "url(#5h3z15zrpbR)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "dkn6nrsyebT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qhc56q68gbS"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B5B7",
    fillRule: "nonzero",
    d: "M1.952 2.802l3.085-1.793c.08.02.159.038.237.053L2.19 2.854c-.079-.015-.158-.033-.238-.052",
    mask: "url(#dkn6nrsyebT)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mcik9q5yebV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kfjkmiyqdbU"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AFB1B3",
    fillRule: "nonzero",
    d: "M2.19 2.854l3.084-1.792c.086.017.17.03.254.042L2.443 2.896c-.083-.01-.168-.025-.253-.042",
    mask: "url(#mcik9q5yebV)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "akvhukglgbX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9n5i3o3wkbW"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AAADAF",
    fillRule: "nonzero",
    d: "M2.443 2.896l3.085-1.792c.087.011.173.02.257.026L2.701 2.923c-.085-.006-.17-.015-.258-.027",
    mask: "url(#akvhukglgbX)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "34efy8sc4bZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#40e49z671bY"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A6A8AB",
    fillRule: "nonzero",
    d: "M2.701 2.923L5.785 1.13c.092.006.183.01.272.009L2.973 2.932c-.09 0-.18-.003-.272-.01",
    mask: "url(#34efy8sc4bZ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "884ctvzoacb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#roys96kvhca"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A2A4A7",
    fillRule: "nonzero",
    d: "M2.973 2.931L6.058 1.14c.101 0 .201-.005.3-.014L3.274 2.917c-.099.01-.2.014-.3.014",
    mask: "url(#884ctvzoacb)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "s2s367l0lcd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kq1gsly34cc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9EA0A3",
    fillRule: "nonzero",
    d: "M3.273 2.917l3.085-1.792c.113-.01.225-.027.333-.048L3.607 2.869c-.109.022-.22.038-.334.048",
    mask: "url(#s2s367l0lcd)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "8kbmvmqz3cf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0h88ga05bce"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9A9C9F",
    fillRule: "nonzero",
    d: "M3.607 2.87l3.084-1.794c.14-.027.275-.065.405-.11L4.012 2.756c-.13.047-.266.084-.405.112",
    mask: "url(#8kbmvmqz3cf)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "xw61ziyqgch",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w4znrz441cg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#96999B",
    fillRule: "nonzero",
    d: "M4.012 2.758L7.096.965c.164-.058.32-.13.47-.217L4.48 2.541c-.149.086-.305.159-.47.217",
    mask: "url(#xw61ziyqgch)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(14.088 16.642)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0s0dv3y36cj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fddndu4teci"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#112955",
    fillRule: "nonzero",
    d: "M.362 2.255L3.446.463l.048.01L.409 2.265l-.047-.01",
    mask: "url(#0s0dv3y36cj)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(14.088 16.642)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "44qapkdpscl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kc1mg0wklck"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#112955",
    fillRule: "nonzero",
    d: "M.41 2.265L3.493.473l.013.002L.422 2.268.41 2.265",
    mask: "url(#44qapkdpscl)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "1db509bndcn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p3cv422rlcm"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#102853",
    fillRule: "nonzero",
    d: "M.422 2.268L3.506.475l.032.006L.454 2.274l-.032-.006",
    mask: "url(#1db509bndcn)"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    d: "M5.222 1.012C5.18 1.007 5.137 1 5.094.992c-.114-.02-.23-.045-.347-.076l-.05-.013c-.12-.034-.24-.073-.364-.118L4.286.767c-.124-.047-.25-.1-.378-.16L3.863.584C3.726.52 3.587.446 3.447.365L2.95.653l-.422.245-.625.363-.625.364-.422.245-.495.287c.053.031.105.06.157.088.068.037.135.072.203.105l.057.028.045.02.097.047c.067.029.133.057.198.083l.083.031c.016.006.031.013.047.018l.07.026c.066.023.131.045.196.065l.098.027.05.013.057.016c.068.018.135.032.202.045l.088.015.031.006.003-.001.094.016 3.084-1.793z",
    transform: "translate(21 32) translate(12.579 16.138)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082049",
    d: "M1.872 2.759l.047.01-.047-.01",
    transform: "translate(21 32) translate(12.579 16.138)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(14.088 16.642)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mwvtievz6cp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fek8zjc3oco"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#102853",
    fillRule: "nonzero",
    d: "M.454 2.274L3.538.48l.08.014L.534 2.287l-.08-.013",
    mask: "url(#mwvtievz6cp)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(14.591 16.642)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "le3y313becr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#symbmnnjkcq"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#102853",
    fillRule: "nonzero",
    d: "M.03 2.287L3.115.495l.04.006L.07 2.293l-.04-.006",
    mask: "url(#le3y313becr)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(14.591 16.642)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "09vs2qdzxct",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qxprn6vhtcs"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#102853",
    fillRule: "nonzero",
    d: "M.07 2.293L3.155.501l.05.007L.12 2.301l-.05-.008",
    mask: "url(#09vs2qdzxct)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "9w2gumuvycv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nihjjydb9cu"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0F2752",
    fillRule: "nonzero",
    d: "M.12 2.3L3.204.509 3.22.51.135 2.303.12 2.3",
    mask: "url(#9w2gumuvycv)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(14.591 17.145)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5yqiyn9opcx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1s83gqtqacw"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0F2752",
    fillRule: "nonzero",
    d: "M.135 1.8L3.22.006l.034.004L.169 1.804l-.034-.005",
    mask: "url(#5yqiyn9opcx)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(14.591 17.145)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "q7d3x8i54cz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gvafyfqyocy"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0F2752",
    fillRule: "nonzero",
    d: "M.17 1.804L3.253.01h.003L.172 1.805H.17",
    mask: "url(#q7d3x8i54cz)"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C3C3C3",
    d: "M2.673 4.702L5.757 2.909 5.753 4.54 2.668 6.332z",
    transform: "translate(21 32) translate(9.56 9.597)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CECDCC",
    d: "M0.162 1.988L3.246 0.195 4.662 1.013 1.578 2.805z",
    transform: "translate(21 32) translate(9.56 9.597)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(11.07 10.604)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rh2dqkgslcB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jryqr0gytcA"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#244978",
    fillRule: "nonzero",
    d: "M.069 1.799L3.153.006l.022.077L.091 1.875.07 1.8",
    mask: "url(#rh2dqkgslcB)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "fstqmtsj5cD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#drz20jbb7cC"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#244A79",
    fillRule: "nonzero",
    d: "M.091 1.876L3.175.083l.033.102L.123 1.977l-.032-.101",
    mask: "url(#fstqmtsj5cD)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "xvtyjaf3wcF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uy51bwjmmcE"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#254B7B",
    fillRule: "nonzero",
    d: "M.124 1.977L3.208.184l.035.1L.158 2.075l-.034-.098",
    mask: "url(#xvtyjaf3wcF)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "loqadmhqkcH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e9ucfqon0cG"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#264C7D",
    fillRule: "nonzero",
    d: "M.158 2.076L3.243.283c.011.033.023.064.036.097L.194 2.172l-.036-.096",
    mask: "url(#loqadmhqkcH)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "4hfm9tc4fcJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0ty9ks4h5cI"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#264E7E",
    fillRule: "nonzero",
    d: "M.194 2.172L3.28.38l.03.077L.227 2.25l-.032-.077",
    mask: "url(#4hfm9tc4fcJ)"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3772A2",
    d: "M1.165 3.271L4.249 1.478 4.248 1.903 1.164 3.696z",
    transform: "translate(21 32) translate(11.07 10.604)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D7CB0",
    d: "M0.069 1.799L3.153 0.006 3.522 0.22 0.438 2.012z",
    transform: "translate(21 32) translate(11.07 10.604)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(12.075 12.113)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "24z8vho65cL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tk6937rcucK"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1D396B",
    fillRule: "nonzero",
    d: "M.157 2.186L3.242.393l.02.021L.176 2.206l-.02-.02",
    mask: "url(#24z8vho65cL)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "cqbefmughcN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5wshu40pvcM"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C3869",
    fillRule: "nonzero",
    d: "M.177 2.206L3.261.414l.083.083L.26 2.288c-.028-.026-.055-.054-.083-.082",
    mask: "url(#cqbefmughcN)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "lsahcfe46cP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dd8y3aytzcO"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C3768",
    fillRule: "nonzero",
    d: "M.26 2.288L3.345.496c.028.027.056.054.086.08L.346 2.368c-.029-.026-.058-.052-.086-.08",
    mask: "url(#lsahcfe46cP)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "1b9krer4jcR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s9iwcsk6zcQ"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1B3667",
    fillRule: "nonzero",
    d: "M.346 2.368L3.43.576c.03.026.058.052.088.076L.433 2.444c-.029-.024-.058-.05-.087-.076",
    mask: "url(#1b9krer4jcR)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "knq8x8x8gcT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f90x28cvecS"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1B3565",
    fillRule: "nonzero",
    d: "M.433 2.445L3.518.652l.087.071L.52 2.516l-.087-.071",
    mask: "url(#knq8x8x8gcT)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "32ljgfzhhcV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g65j9df1fcU"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A3464",
    fillRule: "nonzero",
    d: "M.52 2.515L3.605.723 3.69.79.606 2.58.52 2.515",
    mask: "url(#32ljgfzhhcV)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a5mxj5h54cX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0lnnqg123cW"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#193363",
    fillRule: "nonzero",
    d: "M.606 2.581L3.691.788c.028.022.056.041.084.06L.691 2.642l-.085-.06",
    mask: "url(#a5mxj5h54cX)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "0yvubpxpkcZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wb26eswiucY"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#193261",
    fillRule: "nonzero",
    d: "M.69 2.641L3.776.848l.083.056L.774 2.696.69 2.64",
    mask: "url(#0yvubpxpkcZ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "5mjiwdi45db",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#069vcj1n7da"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#183160",
    fillRule: "nonzero",
    d: "M.774 2.696L3.858.903c.027.018.055.035.082.05L.856 2.747l-.082-.05",
    mask: "url(#5mjiwdi45db)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "d83cao4fddd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l2oi4rvzfdc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#17305E",
    fillRule: "nonzero",
    d: "M.856 2.746L3.94.954l.019.01C3.98.978 4 .99 4.022 1L.937 2.792l-.062-.035-.02-.01",
    mask: "url(#d83cao4fddd)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "5vwnlx4xodf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8m72eyc9dde"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#162F5D",
    fillRule: "nonzero",
    d: "M.937 2.792L4.022.999c.026.015.053.029.08.042L1.016 2.833c-.026-.012-.053-.026-.08-.041",
    mask: "url(#5vwnlx4xodf)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "qt2rxlgs6dh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tty9kr3ogdg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#152E5C",
    fillRule: "nonzero",
    d: "M1.017 2.833L4.1 1.041l.08.037L1.094 2.87c-.026-.011-.052-.024-.078-.037",
    mask: "url(#qt2rxlgs6dh)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "9ohm53ol9dj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9jswdmotvdi"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#152D5A",
    fillRule: "nonzero",
    d: "M1.095 2.87L4.18 1.079l.078.033-3.084 1.792-.079-.032",
    mask: "url(#9ohm53ol9dj)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "ny6cpjc4ndl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uw6ww7xfjdk"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#142C59",
    fillRule: "nonzero",
    d: "M1.174 2.903l3.084-1.792.078.03-3.084 1.792-.078-.03",
    mask: "url(#ny6cpjc4ndl)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "8s746qo79dn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#drbm8mwtidm"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#132B57",
    fillRule: "nonzero",
    d: "M1.252 2.933L4.336 1.14c.027.01.053.019.079.026L1.33 2.96c-.027-.008-.053-.016-.079-.026",
    mask: "url(#8s746qo79dn)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "io2ud753edp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dztfowab1do"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#122A56",
    fillRule: "nonzero",
    d: "M1.33 2.959l3.085-1.793c.027.008.053.016.08.022L1.41 2.981l-.08-.022",
    mask: "url(#io2ud753edp)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "vf8gdkl2jdr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9icajel8zdq"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#112955",
    fillRule: "nonzero",
    d: "M1.41 2.98l3.085-1.792c.027.007.054.014.081.019L1.492 2.999 1.41 2.98",
    mask: "url(#vf8gdkl2jdr)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "aqaw3bq27dt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k0ldbritzds"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#102853",
    fillRule: "nonzero",
    d: "M1.492 2.999l3.084-1.793.084.015-3.084 1.792c-.028-.004-.056-.008-.084-.014",
    mask: "url(#aqaw3bq27dt)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "n9sxikrvwdv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#poku69xq9du"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0F2752",
    fillRule: "nonzero",
    d: "M1.576 3.013L4.66 1.22l.02.003-3.084 1.793-.02-.003",
    mask: "url(#n9sxikrvwdv)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(10.566 8.591)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mdeeapcp7dx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4nb906o28dw"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0C234D",
    fillRule: "nonzero",
    d: "M.576 2.161L3.661.368 3.632.44.548 2.233l.028-.072",
    mask: "url(#mdeeapcp7dx)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "eh62okqj8dz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lk0kr6y8ddy"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0D244F",
    fillRule: "nonzero",
    d: "M.548 2.232L3.632.44c-.012.033-.023.068-.034.104L.514 2.335c.01-.035.021-.07.034-.103",
    mask: "url(#eh62okqj8dz)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "bdgsajyqadB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w63pnj6krdA"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0E2650",
    fillRule: "nonzero",
    d: "M.514 2.335L3.598.543c-.01.032-.018.065-.026.099L.488 2.434c.008-.034.016-.067.026-.099",
    mask: "url(#bdgsajyqadB)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "5a1qk7eltdD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q8ywp7odrdC"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0F2752",
    fillRule: "nonzero",
    d: "M.488 2.434L3.572.642l-.019.095L.47 2.53c.006-.032.012-.064.02-.095",
    mask: "url(#5a1qk7eltdD)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "nzxfbo6cmdF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yha0p08oudE"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#102853",
    fillRule: "nonzero",
    d: "M.469 2.53L3.553.737c-.005.03-.01.062-.013.093L.455 2.623.47 2.53",
    mask: "url(#nzxfbo6cmdF)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "wqt90o6fldH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tfzyqq3yldG"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#112955",
    fillRule: "nonzero",
    d: "M.455 2.623L3.54.83l-.01.093L.446 2.716c.002-.032.005-.062.01-.093",
    mask: "url(#wqt90o6fldH)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "skambg3oedJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0sk6leyjhdI"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#122A56",
    fillRule: "nonzero",
    d: "M.446 2.716L3.53.923c-.003.03-.005.062-.006.093L.44 2.81c.001-.032.003-.063.006-.093",
    mask: "url(#skambg3oedJ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "dbwp7qhzddL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1vadpknfddK"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#132B57",
    fillRule: "nonzero",
    d: "M.44 2.809l3.084-1.793-.002.094L.438 2.902c0-.031 0-.063.002-.093",
    mask: "url(#dbwp7qhzddL)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "ay56yf23sdN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1yi3buvbpdM"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#142C59",
    fillRule: "nonzero",
    d: "M.438 2.902l3.084-1.793v.006l.001.088L.44 2.996l-.001-.088v-.006",
    mask: "url(#ay56yf23sdN)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "cg8x7z2wfdP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2ok17cscgdO"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#152D5A",
    fillRule: "nonzero",
    d: "M.439 2.996l3.084-1.793.005.095L.443 3.09.44 2.996",
    mask: "url(#cg8x7z2wfdP)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "pfv5h8hv0dR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9ptccgdjtdQ"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#152E5C",
    fillRule: "nonzero",
    d: "M.443 3.09l3.084-1.792.008.095L.451 3.185.443 3.09",
    mask: "url(#pfv5h8hv0dR)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "1f05cwhhzdT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bfxb4sh0bdS"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#162F5D",
    fillRule: "nonzero",
    d: "M.45 3.185l3.085-1.793.01.096L.462 3.28l-.01-.095",
    mask: "url(#1f05cwhhzdT)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "9bqqczyjrdV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#payj5n7b3dU"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#17305E",
    fillRule: "nonzero",
    d: "M.461 3.28l3.085-1.792c.004.032.008.065.014.098L.476 3.378.46 3.28",
    mask: "url(#9bqqczyjrdV)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "sx7xetdjpdX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ns1ts6sabdW"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#183160",
    fillRule: "nonzero",
    d: "M.475 3.378L3.56 1.585c.005.034.01.066.017.1L.493 3.477l-.018-.099",
    mask: "url(#sx7xetdjpdX)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "hoskapuk5dZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#txijde3yndY"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#193261",
    fillRule: "nonzero",
    d: "M.493 3.477l3.084-1.792.02.101L.513 3.58l-.02-.102",
    mask: "url(#hoskapuk5dZ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "udkjpcxekeb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n4yrs3iy7ea"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#193363",
    fillRule: "nonzero",
    d: "M.513 3.579l3.084-1.793.024.103L.537 3.681.513 3.58",
    mask: "url(#udkjpcxekeb)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "ij3p2bstjed",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xk9toiji4ec"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A3464",
    fillRule: "nonzero",
    d: "M.537 3.681L3.621 1.89l.028.104L.564 3.785c-.01-.034-.018-.07-.027-.104",
    mask: "url(#ij3p2bstjed)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "8n8w69im3ef",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oc9pm9xcgee"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1B3565",
    fillRule: "nonzero",
    d: "M0.564 3.785L3.649 1.992 3.656 2.019 0.572 3.812z",
    mask: "url(#8n8w69im3ef)"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3772A2",
    d: "M4.113 6.618L7.197 4.825 7.196 5.248 4.112 7.041z",
    transform: "translate(21 32) translate(9.56 8.088)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D7CB0",
    d: "M1.583 2.664L4.667 0.871 5.036 1.085 1.952 2.878z",
    transform: "translate(21 32) translate(9.56 8.088)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8A8A8",
    d: "M4.422 7.04L7.507 5.247 7.502 6.843 4.418 8.636z",
    transform: "translate(21 32) translate(9.56 8.088)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193363",
    d: "M0.167 1.847L3.251 0.054 4.667 0.872 1.582 2.664z",
    transform: "translate(21 32) translate(9.56 8.088)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(11.07 8.591)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3vn7xk45teh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6d82esu2qeg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#113056",
    fillRule: "nonzero",
    d: "M.17 1.98L3.252.189 3.25.196.165 1.988l.004-.007",
    mask: "url(#3vn7xk45teh)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "5hw7y43koej",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cflp5rjrqei"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#123158",
    fillRule: "nonzero",
    d: "M.164 1.988L3.25.196c-.027.042-.05.085-.073.132L.092 2.12c.022-.046.046-.09.072-.132",
    mask: "url(#5hw7y43koej)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "qmnpaky5ael",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dlua1f33uek"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#13335A",
    fillRule: "nonzero",
    d: "M.092 2.12L3.176.328l-.018.04L.073 2.162l.019-.041",
    mask: "url(#qmnpaky5ael)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(11.07 8.591)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ir0thhv7jen",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u4jubtjilem"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4388C2",
    fillRule: "nonzero",
    d: "M.17 1.98L3.252.189l.008.009L.177 1.989l-.008-.008",
    mask: "url(#ir0thhv7jen)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "fxc9nhhbfep",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4eeqesf6qeo"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4286BE",
    fillRule: "nonzero",
    d: "M.177 1.99L3.26.195 3.3.235.215 2.027l-.038-.038",
    mask: "url(#fxc9nhhbfep)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "7edtnw85ter",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#66u1dhyjveq"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4184BB",
    fillRule: "nonzero",
    d: "M.215 2.027L3.3.234l.039.037L.254 2.063l-.039-.036",
    mask: "url(#7edtnw85ter)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "5p9rl3xiget",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oy0ckuhc6es"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4082B8",
    fillRule: "nonzero",
    d: "M.255 2.063L3.339.271l.04.035L.295 2.098l-.04-.035",
    mask: "url(#5p9rl3xiget)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "pz2coxrexev",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yuz5pyczueu"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3F80B5",
    fillRule: "nonzero",
    d: "M.295 2.098L3.379.306l.04.033L.334 2.13l-.04-.033",
    mask: "url(#pz2coxrexev)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "6sa9z4ea9ex",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y7savtaanew"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3E7EB3",
    fillRule: "nonzero",
    d: "M.334 2.131L3.42.338l.039.03L.374 2.162l-.04-.03",
    mask: "url(#6sa9z4ea9ex)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "on620m1udez",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j6mskrvrney"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3C7CB0",
    fillRule: "nonzero",
    d: "M.374 2.16L3.458.369l.039.028L.412 2.188C.399 2.18.386 2.171.374 2.161",
    mask: "url(#on620m1udez)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "rzbuikhl8eB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7pc0eeoseeA"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3B7AAD",
    fillRule: "nonzero",
    d: "M.412 2.188L3.496.395l.031.022L.443 2.209l-.031-.02",
    mask: "url(#rzbuikhl8eB)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#3772A2",
    fillRule: "nonzero",
    d: "M11.512 10.8L14.596 9.007 14.596 9.173 11.512 10.965z",
    transform: "translate(21 32)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(11.07 8.591)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pc6kv5y82eD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xs14womgfeC"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3B7AAD",
    fillRule: "nonzero",
    d: "M.443 2.209L3.527.416l.01.006L.453 2.215l-.01-.006",
    mask: "url(#pc6kv5y82eD)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "y9gybpu5reF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wg8skzn1aeE"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3A78AA",
    fillRule: "nonzero",
    d: "M.453 2.215L3.537.422l.037.023L.489 2.237l-.036-.022",
    mask: "url(#y9gybpu5reF)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "uwasg5wfceH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xrnxy8vbweG"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3975A7",
    fillRule: "nonzero",
    d: "M.49 2.237L3.573.444 3.58.45l.028.016L.525 2.257l-.03-.016-.006-.004",
    mask: "url(#uwasg5wfceH)"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3D7CB0",
    d: "M5.623 9.133L8.707 7.341 9.017 7.52 5.933 9.312z",
    transform: "translate(21 32) translate(8.05 5.572)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3772A2",
    d: "M6.354 8.716L9.438 6.923 9.437 7.283 6.353 9.076z",
    transform: "translate(21 32) translate(8.05 5.572)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D7CB0",
    d: "M6.354 8.716L9.438 6.923 9.805 7.135 6.721 8.928z",
    transform: "translate(21 32) translate(8.05 5.572)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CECDCC",
    d: "M1.864 4.114L4.949 2.321 6.079 2.974 2.995 4.767z",
    transform: "translate(21 32) translate(8.05 5.572)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3C3C3",
    d: "M1.453 2.967L4.538 1.174 4.949 2.322 1.864 4.114z",
    transform: "translate(21 32) translate(8.05 5.572)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CECDCC",
    d: "M7.501 2.914c0-.013 0-.028-.002-.043l-.003-.044-.003-.025-.002-.021-.007-.045-.007-.046-.01-.046-.011-.048-.013-.048-.014-.047-.01-.03v-.003l-.004-.014-.016-.045-.017-.045-.017-.043-.019-.043-.02-.043c-.006-.015-.014-.03-.022-.046-.007-.016-.016-.031-.024-.047l-.003-.005-.04-.075c-.027-.043-.053-.086-.081-.127l-.014-.02-.008-.01-.03-.041c-.011-.017-.024-.034-.036-.05l-.035-.042-.034-.04L6.97 1.7l-.008-.008-.036-.04-.039-.037-.04-.037-.04-.035-.011-.01-.004-.002-.025-.02-.04-.031c-.013-.01-.025-.019-.038-.027-.013-.009-.025-.018-.039-.026l-.037-.023-.009-.005-3.084 1.793c.064.037.127.081.188.13l.004.004c.06.05.118.106.174.166.058.063.112.132.163.204l.007.01c.051.074.098.15.14.228.055.105.102.215.138.326v.003c.037.11.062.222.074.33.005.052.009.102.009.152 0 .07-.007.134-.019.193v.006c-.013.058-.03.112-.052.159v.002c-.016.032-.035.056-.053.082-.04.055-.084.104-.139.135L7.24 3.531c.054-.032.099-.08.138-.135.005-.007.013-.01.017-.017.012-.02.024-.04.034-.062l.001-.003.001-.003.02-.045.016-.047.012-.046.003-.02.002-.005c0-.007.002-.013.003-.02l.007-.042.004-.044L7.501 3v-.046-.04",
    transform: "translate(21 32) translate(8.05 5.572)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CECDCC",
    d: "M3.169 3.073h.003c.053.005.108.016.166.036h.002c.06.02.12.048.181.083l3.084-1.791-.028-.017-.037-.019-.036-.017-.036-.015c-.012-.005-.024-.01-.036-.013l-.007-.002-.003-.001c-.008-.003-.017-.007-.026-.009l-.037-.01-.036-.009-.04-.006-.026-.003h-.014c-.014-.002-.028-.002-.041-.002-.016 0-.031 0-.047.002-.018.001-.035.004-.051.007h-.002l-.002.001c-.02.004-.04.01-.06.016-.024.01-.05.02-.072.034L2.884 3.13c.04-.023.085-.04.132-.049h.002c.047-.01.098-.013.15-.008M5.927 11.152L9.012 9.359 9.801 10.291 6.717 12.084zM.323 2.319L3.407.527 4.538 1.175 1.453 2.967z",
    transform: "translate(21 32) translate(8.05 5.572)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D396B",
    d: "M3.099 2.029L6.183 0.237 6.972 1.169 3.888 2.961z",
    transform: "translate(21 32) translate(8.05 5.572)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CECDCC",
    d: "M6.721 8.928L9.805 7.135 11.224 7.954 8.14 9.747z",
    transform: "translate(21 32) translate(8.05 5.572)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    d: "M9.943 6.3l-.005-.093-.008.004.008-.004-.007-.095-.011-.096-.01-.069v-.008l-.004-.02-.017-.1-.02-.1-.025-.104c-.008-.034-.017-.069-.027-.103l-.007-.026-3.085 1.791c.044.153.077.305.1.455l.001.007c.022.15.034.298.034.442 0 .144-.013.278-.036.401l-.002.01c-.024.123-.057.235-.101.336l3.084-1.793c.01-.023.02-.046.028-.07.013-.034.025-.068.035-.104.01-.032.018-.065.025-.099l.013-.062.002-.01.004-.023.014-.093.01-.093.006-.093.002-.093v-.006l-.001-.088",
    transform: "translate(21 32) translate(8.05 5.572)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D7CB0",
    d: "M6.359 7.066L9.443 5.274 9.81 5.485 6.726 7.278z",
    transform: "translate(21 32) translate(8.05 5.572)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CECDCC",
    d: "M3.41 1.99L6.494 0.197 7.283 1.129 4.199 2.922z",
    transform: "translate(21 32) translate(8.05 5.572)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3C3C3",
    d: "M4.199 2.922L7.283 1.129 7.281 2.142 4.196 3.935z",
    transform: "translate(21 32) translate(8.05 5.572)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3772A2",
    d: "M5.633 5.384L8.717 3.591 8.716 4.015 5.632 5.807z",
    transform: "translate(21 32) translate(8.05 5.572)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    d: "M5.633 5.384L8.717 3.59l-.022-.023-.083-.082-.086-.08-.087-.076-.066-.053-.007-.006-.014-.012-.086-.066-.085-.06-.083-.054c-.027-.018-.054-.034-.082-.05l-.02-.011c-.02-.013-.04-.024-.061-.035-.027-.015-.053-.028-.08-.041-.026-.014-.052-.026-.078-.038l-.031-.013-.012-.005-.035-.015-.079-.03-.079-.025-.048-.014L4.41 4.595c.078.021.159.049.24.084l.013.004c.082.036.166.078.25.127.127.073.25.158.37.253l.007.006c.119.095.234.2.344.315",
    transform: "translate(21 32) translate(8.05 5.572)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(14.591 10.604)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ki2v2vbh4eJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#91z3yzafjeI"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4388C2",
    fillRule: "nonzero",
    d: "M.03 1.8L3.114.007c.01.024.02.049.028.073L.06 1.873.029 1.8",
    mask: "url(#ki2v2vbh4eJ)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "gm53n4zy4eL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#heyrzjfqceK"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4286BE",
    fillRule: "nonzero",
    d: "M.059 1.873L3.143.08l.036.097L.095 1.969l-.036-.096",
    mask: "url(#gm53n4zy4eL)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "5datgfqqbeN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tx5uospsueM"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4184BB",
    fillRule: "nonzero",
    d: "M.095 1.97L3.179.176c.012.033.024.066.034.099L.13 2.068l-.034-.099",
    mask: "url(#5datgfqqbeN)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "66elgeg9reP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rus3u1hm7eO"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4082B8",
    fillRule: "nonzero",
    d: "M.13 2.068L3.213.275l.032.102L.162 2.17l-.033-.1",
    mask: "url(#66elgeg9reP)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "szfwh4o5ceR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ujz43tz7neQ"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3F80B5",
    fillRule: "nonzero",
    d: "M.162 2.17L3.246.376l.023.077L.185 2.246l-.023-.077",
    mask: "url(#szfwh4o5ceR)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(13.585 9.094)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dc1tv0ym4eT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cs6filxdleS"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4388C2",
    fillRule: "nonzero",
    d: "M.099 1.862L3.183.069l.056.06L.155 1.922l-.056-.06",
    mask: "url(#dc1tv0ym4eT)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "x97fkt9wweV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d4msj4bn3eU"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#448CC6",
    fillRule: "nonzero",
    d: "M.155 1.922L3.24.129l.076.084L.231 2.005l-.076-.083",
    mask: "url(#x97fkt9wweV)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "tf83tl8y7eX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ms44eblkveW"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5D96CC",
    fillRule: "nonzero",
    d: "M.23 2.005L3.316.213 3.389.3.305 2.092l-.074-.087",
    mask: "url(#tf83tl8y7eX)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "peyso21qseZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a54cjv7a1eY"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#669ACE",
    fillRule: "nonzero",
    d: "M.305 2.092L3.39.3c.026.03.05.062.075.093L.38 2.185l-.075-.093",
    mask: "url(#peyso21qseZ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "z062wxte0fb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8ytmtyu73fa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6D9DD0",
    fillRule: "nonzero",
    d: "M.38 2.185L3.465.392l.028.037L.408 2.22.38 2.185",
    mask: "url(#z062wxte0fb)"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    d: "M1.036 6.328L4.12 4.535l-.009-.02c-.013-.031-.026-.063-.04-.093-.013-.032-.027-.063-.042-.094l-.048-.1c-.02-.038-.039-.076-.06-.113l-.075-.138-.006-.01-.008-.014c-.055-.094-.113-.187-.174-.277-.036-.053-.073-.105-.111-.156l-.054-.073L.408 5.24c.127.164.243.339.348.52l.005.01c.104.18.197.368.275.558",
    transform: "translate(21 32) translate(13.585 6.075)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193363",
    d: "M1.191 6.774L4.275 4.982 5.694 5.801 2.61 7.594z",
    transform: "translate(21 32) translate(13.585 6.075)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#162F5C",
    d: "M0.103 3.249L3.188 1.457 3.183 3.088 0.099 4.881z",
    transform: "translate(21 32) translate(13.585 6.075)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADADAD",
    d: "M1.036 6.328L4.12 4.535 5.508 5.337 2.423 7.129z",
    transform: "translate(21 32) translate(13.585 6.075)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3C3C3",
    d: "M0.413 3.646L3.497 1.854 3.493 3.447 0.408 5.24z",
    transform: "translate(21 32) translate(13.585 6.075)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C6D6D",
    d: "M3.026 6.924L6.11 5.131 5.694 5.802 2.61 7.594z",
    transform: "translate(21 32) translate(13.585 6.075)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADADAD",
    d: "M0.103 3.249L3.188 1.457 3.976 1.437 0.893 3.229z",
    transform: "translate(21 32) translate(13.585 6.075)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B224C",
    d: "M2.84 6.459L5.924 4.667 5.508 5.337 2.423 7.129z",
    transform: "translate(21 32) translate(13.585 6.075)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F2651",
    d: "M0.413 3.646L3.497 1.854 4.289 1.836 1.205 3.628z",
    transform: "translate(21 32) translate(13.585 6.075)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193363",
    d: "M3.026 6.924L6.11 5.131 7.16 5.738 4.076 7.53z",
    transform: "translate(21 32) translate(13.585 6.075)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#162F5C",
    d: "M0.896 2.022L3.98 0.229 3.977 1.437 0.892 3.229z",
    transform: "translate(21 32) translate(13.585 6.075)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CECDCC",
    d: "M2.84 6.459L5.924 4.667 7.05 5.317 3.966 7.109z",
    transform: "translate(21 32) translate(13.585 6.075)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8A8A8",
    d: "M1.182 11.58L4.267 9.788 4.263 11.081 1.179 12.873zM2.605 9.244L5.689 7.451 6.1 8.599 3.016 10.391z",
    transform: "translate(21 32) translate(13.585 6.075)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(17.107 11.107)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6prk8asskfd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zdctcj09ofc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#244978",
    fillRule: "nonzero",
    d: "M.444 2.078L3.528.286l.012.043.008.028L.464 2.15.456 2.12l-.012-.043",
    mask: "url(#6prk8asskfd)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "ko29ytabxff",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vee4xg59ife"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#234876",
    fillRule: "nonzero",
    d: "M.464 2.15L3.548.357l.019.069.013.05.031.119.002.008L.53 2.395l-.002-.008-.031-.12-.013-.048-.02-.07",
    mask: "url(#ko29ytabxff)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "ph27y2vd8fh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ed0iyvu3ifg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#224674",
    fillRule: "nonzero",
    d: "M.529 2.395L3.613.602l.009.037.016.067L.554 2.5.538 2.43l-.01-.036",
    mask: "url(#ph27y2vd8fh)"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#123155",
    d: "M2.397.282c.255.147.498.343.72.574v.422l.31.18v-.244c.255.331.47.704.627 1.09l-.21-.123v.357l.366.211c.087.307.135.613.134.904-.001.292-.05.542-.14.747l-.365-.212-.001.36.208.12c-.16.2-.375.324-.63.36l.001-.244-.31-.179-.001.423c-.224-.027-.467-.11-.721-.258-.254-.147-.496-.342-.718-.571l.001-.425-.31-.179v.245c-.256-.33-.471-.703-.63-1.087l.212.122.001-.36-.37-.213C.486 1.995.438 1.69.439 1.398c0-.291.05-.541.138-.747l.37.214V.699l.053.033c.497.287.901.057.903-.514 0-.05-.003-.1-.009-.152.16.044.33.115.504.216",
    transform: "translate(21 32) translate(10.566 10.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#162F5C",
    d: "M4.197 8.848l3.085-1.792-3.085 1.792z",
    transform: "translate(21 32) translate(10.566 10.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    d: "M8.584 6.926c-.116.042-.237.076-.362.101-.07.014-.142.023-.214.032-.056.006-.113.01-.17.014l-.104.005c-.086.002-.173 0-.263-.005h-.014c-.094-.007-.19-.019-.286-.033l-.152-.025-3.085 1.791c.041.009.081.015.122.02l-.002.002.033.004c.021.003.043.008.063.01.074.01.148.018.22.023h.017c.072.005.144.008.215.007l.048-.002c.035 0 .069-.003.104-.005.034-.001.07-.001.103-.005.023-.002.044-.007.067-.01.02-.002.043-.002.064-.005l.005-.002-.005.002c.05-.006.099-.015.147-.024l.002-.001h.004c.12-.025.234-.056.345-.096l.014-.006c.128-.046.251-.102.368-.168h.001l.016-.01L8.97 6.748c-.122.07-.251.129-.386.178",
    transform: "translate(21 32) translate(10.566 10.1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(16.1 15.132)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7tjcgs48wfj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6h6lujvfvfi"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0C234D",
    fillRule: "nonzero",
    d: "M1.438 2.233L4.523.441l-.048.104-3.084 1.792.047-.104",
    mask: "url(#7tjcgs48wfj)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "9lb9zubvpfl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9xqmzr02xfk"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0B224C",
    fillRule: "nonzero",
    d: "M1.391 2.337L4.475.545c-.056.117-.117.228-.183.332L1.208 2.67c.066-.105.127-.216.183-.333",
    mask: "url(#9lb9zubvpfl)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "0f3ck17rsfn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8z915i4h6fm"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#09214B",
    fillRule: "nonzero",
    d: "M1.208 2.67L4.292.877c-.228.36-.518.642-.857.839L.351 3.508c.339-.197.628-.479.857-.838",
    mask: "url(#0f3ck17rsfn)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(16.1 16.642)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mhv0nhindfp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#usqi1tz7efo"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#25557B",
    fillRule: "nonzero",
    d: "M-.048 2.183L3.036.391c.14-.05.273-.111.399-.185L.35 2c-.127.073-.26.135-.4.184",
    mask: "url(#mhv0nhindfp)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillRule: "nonzero",
    d: "M12.546 4.821c-.465.27-.838.701-1.087 1.274L8.375 7.888c.25-.574.622-1.004 1.087-1.275l3.084-1.792",
    transform: "translate(21 32)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(8.05 4.566)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9fuqs5hrhfr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tz76t6rxrfq"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillRule: "nonzero",
    d: "M1.412 2.048L4.496.255c-.338.197-.629.479-.857.839L.555 2.886c.228-.36.518-.642.857-.838",
    mask: "url(#9fuqs5hrhfr)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "s20w62084ft",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f0inad6tlfs"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillRule: "nonzero",
    d: "M.555 2.886l3.084-1.792c-.067.104-.128.215-.183.332L.37 3.218c.056-.116.117-.228.184-.332",
    mask: "url(#s20w62084ft)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "m4sdl9bj5fv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#umonx0qjxfu"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillRule: "nonzero",
    d: "M.371 3.218l3.085-1.792c-.017.034-.032.068-.047.103-.026.06-.05.121-.074.185L.25 3.505c.023-.063.047-.124.073-.183l.047-.104",
    mask: "url(#m4sdl9bj5fv)"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#082049",
    d: "M.706 4.062l.017.072-.017-.072",
    transform: "translate(21 32) translate(7.547 7.585)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2161AC",
    d: "M4.371 7.95l.005-1.594c.098.126.201.246.31.358l-.005 1.63-.792.02-.004 1.206-.05-.049-.033-.03-.087-.087-.037-.037-.072-.073-.027-.028V7.97l.792-.018z",
    transform: "translate(21 32) translate(7.547 7.585)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B2439",
    d: "M4.376 6.356V6.11l.31.179v.424c-.109-.112-.212-.232-.31-.358",
    transform: "translate(21 32) translate(7.547 7.585)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E9",
    d: "M4.024 1.18c.13.075.254.178.366.3.119.13.224.281.31.442.111.212.187.442.212.66.006.051.01.102.009.152-.002.571-.405.801-.903.513l-.053-.032c-.096-.062-.188-.14-.274-.228-.07-.071-.134-.15-.193-.233-.227-.318-.375-.71-.374-1.058.002-.571.405-.801.9-.516",
    transform: "translate(21 32) translate(7.547 7.585)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2161AC",
    d: "M2.367 2.102l1.131.652c.06.084.124.162.193.233-.036.055-.068.115-.096.18L2.18 2.35l-.41-1.148L.716.595.734.541.742.52.775.43.788.4l.03-.072.008-.021 1.13.647.411 1.148zM6.435 7.543L6.43 9.139l.79.932-.004 1.293-.037-.005-.065-.01-.04-.005-.08-.014-.044-.008-.047-.01.003-1.207-.786-.93.005-1.631c.108.013.212.012.31-.001",
    transform: "translate(21 32) translate(7.547 7.585)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B2439",
    d: "M3.595 3.167c.028-.065.06-.124.096-.18.086.088.178.166.274.228v.166l-.37-.214zM6.124 7.544l.001-.423.31.179v.243c-.098.013-.202.014-.31 0M6.863 4.697l.21.122c.061.147.113.297.156.446l-.367-.211.001-.357zM6.135 3.794l.001-.423c.109.113.212.233.31.36v.242l-.311-.179z",
    transform: "translate(21 32) translate(7.547 7.585)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193363",
    d: "M8.866 9.13L11.95 7.337 13.076 7.988 9.992 9.78z",
    transform: "translate(21 32) translate(7.547 7.585)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082049",
    d: "M7.075 11.344l-.08-.014.08.014M7.18 11.36l-.065-.01.064.01",
    transform: "translate(21 32) translate(7.547 7.585)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(9.057 4.063)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lzsqbeu8mfx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m1lgzp1umfw"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#09214B",
    fillRule: "nonzero",
    d: "M.406 2.55L3.49.759c.13-.075.266-.138.408-.188L.814 2.363c-.143.05-.28.113-.408.188",
    mask: "url(#lzsqbeu8mfx)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ehz762kngfz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4a46p7hwlfy"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0B224C",
    fillRule: "nonzero",
    d: "M.814 2.363L3.898.57C4.01.53 4.124.5 4.242.477L1.158 2.269c-.118.024-.233.055-.344.094",
    mask: "url(#ehz762kngfz)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "8hsy3op2ofB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#55ptqp68cfA"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0C234D",
    fillRule: "nonzero",
    d: "M1.158 2.27L4.242.475c.092-.018.186-.03.282-.04L1.44 2.23c-.096.009-.19.022-.282.04",
    mask: "url(#8hsy3op2ofB)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "w0fjjyax7fD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tcamkmyc6fC"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0D244F",
    fillRule: "nonzero",
    d: "M1.44 2.229L4.524.436c.083-.007.167-.01.253-.01L1.693 2.216c-.086 0-.17.004-.253.012",
    mask: "url(#w0fjjyax7fD)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "etzl53lsyfF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fvofox1tifE"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0E2650",
    fillRule: "nonzero",
    d: "M1.692 2.217L4.777.425c.076 0 .154.002.233.008L1.926 2.226c-.08-.006-.157-.009-.234-.009",
    mask: "url(#etzl53lsyfF)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "qcu79y3qxfH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h7ethmgnmfG"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0F2752",
    fillRule: "nonzero",
    d: "M1.926 2.225L5.01.433c.057.004.113.01.17.016L2.096 2.242c-.057-.007-.114-.013-.17-.017",
    mask: "url(#qcu79y3qxfH)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#162F5C",
    fillRule: "nonzero",
    d: "M11.153 6.305L14.237 4.512 14.234 5.809 11.149 7.602z",
    transform: "translate(21 32)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(11.07 4.063)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pqjzd710tfJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yi2kt8r20fI"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#17375F",
    fillRule: "nonzero",
    d: "M.084 2.242L3.168.449l.027.003.023.003L.133 2.248.11 2.245l-.026-.003",
    mask: "url(#pqjzd710tfJ)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "1twui0j66fL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hxt11i4y3fK"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#183861",
    fillRule: "nonzero",
    d: "M.133 2.248L3.217.455l.056.008.032.005c.032.006.064.01.096.017l.004.001L.32 2.278H.317L.22 2.26.19 2.256l-.056-.008",
    mask: "url(#1twui0j66fL)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "iwomzuwuffN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kgi8cm6wcfM"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#193A63",
    fillRule: "nonzero",
    d: "M.32 2.278L3.404.486l.016.003L.335 2.28.32 2.278",
    mask: "url(#iwomzuwuffN)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "c7ko7nj4ifP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k8mmkr320fO"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#183861",
    fillRule: "nonzero",
    d: "M.335 2.281L3.42.489h.002L.337 2.28H.335",
    mask: "url(#c7ko7nj4ifP)"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CECDCC",
    d: "M5.532 12.404L8.616 10.611 9.666 11.218 6.582 13.01z",
    transform: "translate(21 32) translate(11.07 4.063)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2161AC",
    d: "M5.532 12.404l1.05.606-.016.046-.014.038-.029.078-.014.036-.026.064-.012.028-1.128-.648-.41-1.144-1.39-.802c.062-.078.115-.168.159-.269l1.419.82.41 1.147zM.337 2.281l.057.012L.39 3.5l.79.93-.003 1.014c-.085-.16-.19-.311-.31-.442l.002-.531-.789-.932.004-1.297.026.003.079.01c.01.003.02.004.031.006l.096.016.02.004",
    transform: "translate(21 32) translate(11.07 4.063)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3C3C3",
    d: "M0.394 2.293L3.478 0.501 3.475 1.707 0.391 3.499z",
    transform: "translate(21 32) translate(11.07 4.063)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(11.07 4.063)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "078cmwaxnfR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0nzrg0kw9fQ"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#112955",
    fillRule: "nonzero",
    d: "M.394 2.293L3.478.5c.052.011.105.023.157.036L.551 2.328c-.053-.012-.105-.025-.157-.035",
    mask: "url(#078cmwaxnfR)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "q2ji8naasfT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0kcc4xgjtfS"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#122A56",
    fillRule: "nonzero",
    d: "M.551 2.329L3.635.536c.067.017.134.036.202.056L.752 2.384c-.067-.02-.134-.039-.2-.055",
    mask: "url(#q2ji8naasfT)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ilqek9ac4fV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rscm4v3wqfU"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#132B57",
    fillRule: "nonzero",
    d: "M.752 2.385L3.837.592c.065.02.132.042.198.065L.951 2.45c-.067-.024-.133-.046-.199-.065",
    mask: "url(#ilqek9ac4fV)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "44h3xqglxfX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2gcae6p5jfW"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#142C59",
    fillRule: "nonzero",
    d: "M.951 2.45L4.035.656c.066.023.132.048.198.074L1.149 2.523.95 2.45",
    mask: "url(#44h3xqglxfX)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "8ion29b7tfZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zgh38vxrefY"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#152D5A",
    fillRule: "nonzero",
    d: "M1.149 2.524L4.233.73l.197.084-3.084 1.793c-.066-.03-.132-.058-.197-.084",
    mask: "url(#8ion29b7tfZ)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "eiazgk6qjgb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#okurwjb7sga"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#152E5C",
    fillRule: "nonzero",
    d: "M1.346 2.608L4.43.815c.066.03.132.06.199.094L1.545 2.701c-.067-.033-.133-.064-.2-.093",
    mask: "url(#eiazgk6qjgb)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "7cxznylsfgd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mp0h4sg9agc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#162F5D",
    fillRule: "nonzero",
    d: "M1.545 2.701L4.629.909c.067.033.134.067.201.104L1.746 2.806c-.067-.037-.135-.072-.201-.105",
    mask: "url(#7cxznylsfgd)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "b9xs2m3p6gf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w860c44yige"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#17305E",
    fillRule: "nonzero",
    d: "M1.746 2.806L4.83 1.013c.053.028.105.058.158.088l.048.028L1.95 2.921l-.047-.027c-.053-.031-.106-.06-.158-.088",
    mask: "url(#b9xs2m3p6gf)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "ghek2sdzkgh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#auhpl4twbgg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#183160",
    fillRule: "nonzero",
    d: "M1.951 2.922l3.085-1.793c.07.041.139.084.208.127L2.16 3.05c-.07-.044-.139-.087-.209-.127",
    mask: "url(#ghek2sdzkgh)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "dght03g3sgj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6jgfshiihgi"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#193261",
    fillRule: "nonzero",
    d: "M2.16 3.049l3.084-1.793c.07.045.14.091.21.14L2.368 3.186c-.07-.047-.139-.093-.21-.138",
    mask: "url(#dght03g3sgj)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "ykdh3ym09gl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gs8qfyxbwgk"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#193363",
    fillRule: "nonzero",
    d: "M2.37 3.187l3.083-1.792c.072.05.143.1.214.152L2.583 3.339c-.071-.052-.142-.102-.214-.152",
    mask: "url(#ykdh3ym09gl)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "qtitsnu54gn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3rzswm84egm"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A3464",
    fillRule: "nonzero",
    d: "M2.583 3.34l3.084-1.793c.073.053.146.109.217.166L2.8 3.505c-.072-.057-.144-.112-.217-.166",
    mask: "url(#qtitsnu54gn)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "d8tnkb401gp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0c9cum49xgo"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1B3565",
    fillRule: "nonzero",
    d: "M2.8 3.505l3.085-1.793.22.18L3.02 3.685c-.072-.062-.146-.122-.22-.18",
    mask: "url(#d8tnkb401gp)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "sgv7qowrwgr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hd77tntfigq"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1B3667",
    fillRule: "nonzero",
    d: "M3.02 3.685l3.085-1.793c.074.063.148.127.22.193L3.241 3.877c-.073-.065-.146-.13-.22-.192",
    mask: "url(#sgv7qowrwgr)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "f7ydeevfogt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kt9ig6vzqgs"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C3768",
    fillRule: "nonzero",
    d: "M3.241 3.877l3.084-1.792c.058.051.115.104.17.157L3.413 4.034l-.17-.157",
    mask: "url(#f7ydeevfogt)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(8.553 3.057)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nhyspr5adgv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hswebrkvugu"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#25557B",
    fillRule: "nonzero",
    d: "M.303 2.515L3.387.722c.149-.086.305-.158.47-.216L.771 2.297c-.164.06-.32.131-.469.218",
    mask: "url(#nhyspr5adgv)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "s9wsbdw74gx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eiz879d2dgw"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#26577E",
    fillRule: "nonzero",
    d: "M.772 2.298L3.856.505c.13-.045.266-.083.405-.11L1.177 2.185c-.14.029-.275.065-.405.112",
    mask: "url(#s9wsbdw74gx)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "4mnunndzcgz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v1qeift0pgy"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#285981",
    fillRule: "nonzero",
    d: "M1.177 2.187L4.26.394c.109-.021.22-.038.334-.048L1.51 2.138c-.113.01-.225.026-.333.049",
    mask: "url(#4mnunndzcgz)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "rpy392pjxgB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h785n9cv7gA"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2A5C84",
    fillRule: "nonzero",
    d: "M1.51 2.138L4.595.345c.098-.008.198-.013.3-.014L1.811 2.124c-.102 0-.202.005-.3.014",
    mask: "url(#rpy392pjxgB)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "m18f6hsj3gD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5wj2z8lpwgC"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2B5E87",
    fillRule: "nonzero",
    d: "M1.81 2.124L4.896.33c.09 0 .18.003.272.01L2.083 2.133c-.092-.006-.183-.01-.272-.01",
    mask: "url(#m18f6hsj3gD)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "d5q61v0hrgF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7di3ldp4hgE"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2D618B",
    fillRule: "nonzero",
    d: "M2.083 2.133L5.167.34c.085.006.17.015.258.026L2.34 2.16c-.087-.012-.173-.02-.257-.026",
    mask: "url(#d5q61v0hrgF)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "jae0bi92pgH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#crif4d3a0gG"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E638E",
    fillRule: "nonzero",
    d: "M2.34 2.16L5.425.365c.083.012.168.026.253.043L2.593 2.2c-.085-.017-.17-.03-.253-.042",
    mask: "url(#jae0bi92pgH)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "pjslalvgzgJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8771ofd2xgI"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#306591",
    fillRule: "nonzero",
    d: "M2.594 2.2L5.678.409c.078.016.157.033.237.053L2.831 2.253c-.08-.02-.159-.037-.237-.052",
    mask: "url(#pjslalvgzgJ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "ru5drlfdegL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1l60gsdubgK"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#316894",
    fillRule: "nonzero",
    d: "M2.83 2.253L5.916.461c.08.02.16.042.24.066L3.07 2.32c-.08-.025-.16-.046-.24-.067",
    mask: "url(#ru5drlfdegL)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "y4h7vdmqxgN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xlw45puvfgM"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#336A97",
    fillRule: "nonzero",
    d: "M3.07 2.32L6.155.527c.076.023.153.048.231.076L3.302 2.395c-.078-.027-.155-.052-.232-.075",
    mask: "url(#y4h7vdmqxgN)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "s9nbshlqogP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fnkw3a7w0gO"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#346C9A",
    fillRule: "nonzero",
    d: "M3.302 2.395L6.386.603c.078.027.155.057.234.088L3.535 2.483c-.078-.031-.156-.06-.233-.088",
    mask: "url(#s9nbshlqogP)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "5ecoaja8igR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x72v5165ogQ"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#356F9E",
    fillRule: "nonzero",
    d: "M3.535 2.483L6.62.691c.077.03.154.063.231.098L3.767 2.581c-.078-.034-.155-.067-.232-.098",
    mask: "url(#5ecoaja8igR)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "tzrvnu5kugT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bqdsxgllrgS"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3771A1",
    fillRule: "nonzero",
    d: "M3.767 2.582L6.851.789c.078.035.156.071.235.11L4 2.692c-.078-.039-.157-.076-.234-.11",
    mask: "url(#tzrvnu5kugT)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "6mt7ewji3gV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c0ok88v1kgU"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3873A4",
    fillRule: "nonzero",
    d: "M4.001 2.692L7.085.899c.079.04.158.08.237.123L4.238 2.814c-.08-.042-.158-.084-.237-.122",
    mask: "url(#6mt7ewji3gV)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "63hh8pg7ggX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2yf1fvefugW"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3975A7",
    fillRule: "nonzero",
    d: "M4.238 2.815l3.084-1.793c.061.034.123.067.185.103L4.422 2.918c-.062-.036-.122-.07-.184-.103",
    mask: "url(#63hh8pg7ggX)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(17.61 11.61)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8uc4iji6vgZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vv8i4bsa6gY"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#193363",
    fillRule: "nonzero",
    d: "M.05 1.995L3.136.203l.04.173L.09 2.17c-.012-.058-.026-.116-.04-.174",
    mask: "url(#8uc4iji6vgZ)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "4amzr5pxhhb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p59zyfti3ha"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#193261",
    fillRule: "nonzero",
    d: "M.09 2.169L3.175.376l.052.256L.143 2.425C.126 2.34.109 2.255.09 2.169",
    mask: "url(#4amzr5pxhhb)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "8dq74k9e8hd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#at8vcj4rzhc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#183160",
    fillRule: "nonzero",
    d: "M.143 2.425L3.227.632c.015.084.03.168.043.252L.186 2.676c-.013-.084-.028-.167-.043-.251",
    mask: "url(#8dq74k9e8hd)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "jflq0wl5fhf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5aa74hhehe"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#17305E",
    fillRule: "nonzero",
    d: "M.186 2.676L3.27.883c.013.083.025.165.035.247L.22 2.922c-.01-.081-.022-.164-.034-.246",
    mask: "url(#jflq0wl5fhf)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "5pw05o7uwhh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nduw8vf7nhg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#162F5D",
    fillRule: "nonzero",
    d: "M.22 2.922L3.306 1.13c.01.081.02.161.027.242L.248 3.164.22 2.922",
    mask: "url(#5pw05o7uwhh)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "zabj43dtthj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kn9o2u55khi"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#152E5C",
    fillRule: "nonzero",
    d: "M.248 3.164l3.084-1.792c.008.08.014.16.02.24L.266 3.403c-.006-.08-.012-.16-.02-.24",
    mask: "url(#zabj43dtthj)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "vmtimsadrhl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wx8p03oxihk"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#152D5A",
    fillRule: "nonzero",
    d: "M.267 3.404L3.35 1.61c.005.08.009.16.01.238L.278 3.642c-.001-.08-.005-.159-.01-.238",
    mask: "url(#vmtimsadrhl)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "t6r9hkvqnhn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z7dor4s9ohm"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#142C59",
    fillRule: "nonzero",
    d: "M.278 3.642l3.084-1.793.003.224v.013L.281 3.88v-.014c0-.074 0-.149-.003-.223",
    mask: "url(#t6r9hkvqnhn)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "wqy5q00bahp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8zwa997e1ho"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#132B57",
    fillRule: "nonzero",
    d: "M.28 3.879l3.085-1.793c0 .08-.002.159-.006.236L.275 4.114c.004-.077.006-.156.006-.235",
    mask: "url(#wqy5q00bahp)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "tkvvgqrv3hr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4pbmzib8hq"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#122A56",
    fillRule: "nonzero",
    d: "M.275 4.114L3.36 2.321c-.003.08-.008.158-.014.235L.261 4.348c.006-.077.011-.154.014-.234",
    mask: "url(#tkvvgqrv3hr)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "1pwb9wb6bht",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4vb97jdhghs"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#112955",
    fillRule: "nonzero",
    d: "M.26 4.348l3.085-1.792c-.006.08-.014.157-.024.234L.237 4.583c.01-.077.017-.155.024-.235",
    mask: "url(#1pwb9wb6bht)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "sf467qi5dhv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q941m2vabhu"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#102853",
    fillRule: "nonzero",
    d: "M.237 4.582L3.32 2.79c-.01.08-.021.16-.035.236L.202 4.82c.013-.078.024-.156.035-.237",
    mask: "url(#sf467qi5dhv)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "6nsq69nu4hx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mlgj0odprhw"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0F2752",
    fillRule: "nonzero",
    d: "M.202 4.819l3.084-1.793c-.014.083-.03.164-.049.242L.153 5.06c.018-.079.034-.159.049-.241",
    mask: "url(#6nsq69nu4hx)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "1fkecn66ehz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z94q0ln3hhy"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0E2650",
    fillRule: "nonzero",
    d: "M.153 5.06l3.085-1.793c-.02.086-.041.169-.065.25L.09 5.31c.024-.081.045-.164.064-.25",
    mask: "url(#1fkecn66ehz)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "yb5mmqvxjhB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6hpllgm3khA"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0D244F",
    fillRule: "nonzero",
    d: "M.089 5.31l3.084-1.793c-.015.052-.031.104-.048.153L.04 5.463c.017-.05.033-.101.048-.153",
    mask: "url(#yb5mmqvxjhB)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#6C6D6D",
    fillRule: "nonzero",
    d: "M14.789 8.402L17.873 6.609 17.874 7.911 14.79 9.703z",
    transform: "translate(21 32)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(14.088 6.075)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "4mhi2dgashD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6fu5ctmn0hC"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#254B7B",
    fillRule: "nonzero",
    d: "M.393 2.022L3.477.23l.051.049L.444 2.07l-.051-.049",
    mask: "url(#4mhi2dgashD)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "zvaw4pc90hF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5121w545thE"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#264C7D",
    fillRule: "nonzero",
    d: "M.444 2.071L3.528.278l.003.003.003.003L.45 2.077l-.003-.003-.003-.003",
    mask: "url(#zvaw4pc90hF)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "c09ddl0y9hH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1tbt1yj3whG"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#254B7B",
    fillRule: "nonzero",
    d: "M.45 2.077L3.533.284 3.552.3.467 2.093l-.018-.016",
    mask: "url(#c09ddl0y9hH)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "rhpnitgz3hJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qsgcclxa7hI"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#264C7D",
    fillRule: "nonzero",
    d: "M.467 2.093L3.551.301l.005.005c.032.03.063.06.094.092l.035.034.048.05L.648 2.272.6 2.225C.59 2.213.578 2.202.566 2.19l-.094-.092-.005-.005",
    mask: "url(#rhpnitgz3hJ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "tuct4v60chL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k5fdkewuchK"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#264E7E",
    fillRule: "nonzero",
    d: "M.648 2.274L3.733.48l.025.026.027.027L.701 2.326.674 2.3l-.026-.025",
    mask: "url(#tuct4v60chL)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#2161AC",
    fillRule: "nonzero",
    d: "M14.789 8.402v1.301l-.791.019-.005 1.593c-.098-.126-.201-.246-.31-.359l.005-1.631.79-.02.003-1.207.054.052.025.024.094.092.034.034.074.074.027.028",
    transform: "translate(21 32)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(14.591 6.579)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5a7k4mt77hN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iv9a9hhcshM"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1D396B",
    fillRule: "nonzero",
    d: "M.202 1.828L3.286.036c.049.05.097.1.144.152L.346 1.98l-.144-.152",
    mask: "url(#5a7k4mt77hN)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "y6tuwgte4hP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#13k8k2n3whO"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1E3A6C",
    fillRule: "nonzero",
    d: "M.346 1.98L3.43.188c.065.07.129.14.192.213L.538 2.194C.475 2.12.411 2.05.346 1.98",
    mask: "url(#y6tuwgte4hP)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "yz2vi0iqehR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d3bioa6clhQ"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#364876",
    fillRule: "nonzero",
    d: "M.538 2.193L3.622.401c.064.072.126.145.188.219L.725 2.412c-.061-.074-.124-.147-.187-.219",
    mask: "url(#yz2vi0iqehR)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "kc5wcvrf7hT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rbiyj2vxhhS"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#404E7B",
    fillRule: "nonzero",
    d: "M.725 2.412L3.81.62 4 .854.913 2.646C.853 2.568.79 2.49.725 2.412",
    mask: "url(#kc5wcvrf7hT)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "xnqroiqxkhV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#almz2klw6hU"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#47537E",
    fillRule: "nonzero",
    d: "M.915 2.646L3.999.854c.07.09.14.18.209.273L1.124 2.92c-.069-.093-.138-.184-.21-.274",
    mask: "url(#xnqroiqxkhV)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "2c5hifna1hX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h86zbuh8chW"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4D5781",
    fillRule: "nonzero",
    d: "M1.124 2.92l3.084-1.793c.096.13.189.261.28.395L1.404 3.314c-.092-.133-.185-.265-.28-.394",
    mask: "url(#2c5hifna1hX)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "t5vhjz00dhZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9bpxka83ohY"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#525B84",
    fillRule: "nonzero",
    d: "M1.403 3.314l3.085-1.792c.151.223.295.453.432.686L1.836 4.001c-.137-.234-.281-.463-.433-.687",
    mask: "url(#t5vhjz00dhZ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mr4cs5i76ib",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#besuuojsria"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4D5781",
    fillRule: "nonzero",
    d: "M1.836 4L4.92 2.209c.08.138.157.276.232.417L2.068 4.417c-.075-.14-.152-.28-.232-.416",
    mask: "url(#mr4cs5i76ib)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "a3hxp1wm4id",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#628ozc73iic"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#47537E",
    fillRule: "nonzero",
    d: "M2.068 4.417l3.084-1.793c.051.096.1.192.149.29L2.216 4.705c-.047-.097-.097-.194-.148-.29",
    mask: "url(#a3hxp1wm4id)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "xdw2587k8if",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4zgwsqixsie"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#404E7B",
    fillRule: "nonzero",
    d: "M2.217 4.706L5.3 2.913c.042.084.082.168.122.252L2.338 4.957c-.039-.084-.08-.168-.121-.251",
    mask: "url(#xdw2587k8if)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "91s73rp6fih",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tcm43ur1big"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#364876",
    fillRule: "nonzero",
    d: "M2.338 4.957l3.084-1.792c.038.08.074.159.109.238L2.447 5.196c-.035-.08-.072-.16-.109-.239",
    mask: "url(#91s73rp6fih)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "4rmvez3siij",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#saezx2ikxii"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1E3A6C",
    fillRule: "nonzero",
    d: "M2.447 5.196L5.53 3.403c.035.078.068.156.1.235L2.548 5.43c-.032-.079-.066-.157-.1-.235",
    mask: "url(#4rmvez3siij)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "68b60i2e5il",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nhyzudl7fik"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1D396B",
    fillRule: "nonzero",
    d: "M2.547 5.43l3.084-1.792.096.237-3.084 1.793c-.031-.08-.063-.159-.096-.238",
    mask: "url(#68b60i2e5il)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "l4autunmcin",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wal3ve91uim"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C3869",
    fillRule: "nonzero",
    d: "M2.643 5.668l3.084-1.793c.032.081.061.162.091.243L2.734 5.91l-.091-.242",
    mask: "url(#l4autunmcin)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "hf1qldh53ip",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yh71e94uhio"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C3768",
    fillRule: "nonzero",
    d: "M2.734 5.91l3.084-1.792c.03.083.06.167.088.25L2.82 6.16c-.028-.083-.056-.166-.087-.25",
    mask: "url(#hf1qldh53ip)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mj8wnic3dir",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zqci6fjytiq"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1B3667",
    fillRule: "nonzero",
    d: "M2.821 6.16l3.085-1.793c.028.086.056.172.082.258L2.903 6.417c-.026-.086-.053-.171-.082-.257",
    mask: "url(#mj8wnic3dir)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "ip6ggeyqsit",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2aw4egw0is"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1B3565",
    fillRule: "nonzero",
    d: "M2.903 6.417l3.085-1.793c.02.063.038.127.056.19L2.959 6.607c-.017-.064-.036-.127-.056-.19",
    mask: "url(#ip6ggeyqsit)"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2161AC",
    d: "M5.897 13.227c2.726 1.574 4.941.31 4.95-2.82.002-.606-.079-1.236-.23-1.87-.033-.14-.07-.28-.11-.42-.497-1.739-1.498-3.475-2.758-4.779-.102-.106-.206-.21-.312-.31-.475-.45-.982-.837-1.509-1.14-.525-.305-1.033-.502-1.509-.601-.105-.022-.208-.04-.31-.052-1.263-.153-2.273.423-2.778 1.583-.041.094-.078.19-.112.293-.154.458-.238.993-.24 1.597-.009 3.13 2.193 6.946 4.918 8.519M5.93.905c3.2 1.847 5.784 6.323 5.774 9.996-.011 3.676-2.612 5.158-5.811 3.311C2.698 12.367.114 7.891.124 4.215.134.542 2.735-.94 5.93.905",
    transform: "translate(21 32) translate(7.044 5.07)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B2439",
    d: "M7.36 9.579l.208.12c.062-.077.116-.167.159-.268l-.366-.212-.002.36z",
    transform: "translate(21 32) translate(7.044 5.07)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 32) translate(12.579 4.063)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "a5l7jbaddiv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gc3kyhkvgiu"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3975A7",
    fillRule: "nonzero",
    d: "M.397 1.911L3.481.12l.057.033L.454 1.944c-.02-.01-.038-.022-.057-.033",
    mask: "url(#a5l7jbaddiv)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "trut3sfh9ix",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6b4uf7496iw"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3A78AA",
    fillRule: "nonzero",
    d: "M.454 1.944L3.538.152c.082.048.164.099.245.15L.7 2.095c-.08-.053-.163-.102-.245-.15",
    mask: "url(#trut3sfh9ix)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "luuydokl7iz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aupan20x7iy"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3B7AAD",
    fillRule: "nonzero",
    d: "M.7 2.095L3.782.302c.083.053.165.107.247.163L.945 2.257C.864 2.201.782 2.147.7 2.095",
    mask: "url(#luuydokl7iz)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "fayk56di6iB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0nbvv7pv1iA"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3C7CB0",
    fillRule: "nonzero",
    d: "M.945 2.257L4.03.465c.085.058.169.117.253.179L1.197 2.436c-.083-.061-.167-.12-.252-.179",
    mask: "url(#fayk56di6iB)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "kugmmli8oiD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qv96tz919iC"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3E7EB3",
    fillRule: "nonzero",
    d: "M1.197 2.436L4.282.643c.085.063.17.128.254.195L1.45 2.63c-.084-.066-.169-.13-.254-.194",
    mask: "url(#kugmmli8oiD)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "93hm41amliF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uvim4gs4siE"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3F80B5",
    fillRule: "nonzero",
    d: "M1.451 2.63L4.536.838c.086.068.172.138.258.21L1.709 2.84c-.085-.072-.171-.142-.258-.21",
    mask: "url(#93hm41amliF)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "vmsjyr9qciH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f6jn37rugiG"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4082B8",
    fillRule: "nonzero",
    d: "M1.71 2.84l3.083-1.792c.087.073.173.148.258.225L1.967 3.066c-.085-.077-.171-.152-.258-.225",
    mask: "url(#vmsjyr9qciH)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "nzyzn2ukziJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yc8i52p3piI"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4184BB",
    fillRule: "nonzero",
    d: "M1.967 3.066L5.05 1.273c.086.077.17.156.255.237L2.222 3.303c-.084-.08-.17-.16-.255-.237",
    mask: "url(#nzyzn2ukziJ)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "w4xp98u6uiL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wqgl4r1dliK"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4286BE",
    fillRule: "nonzero",
    d: "M2.222 3.302L5.305 1.51c.083.08.164.16.245.241L2.466 3.543c-.08-.082-.162-.162-.244-.24",
    mask: "url(#w4xp98u6uiL)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "vxpimwqswiN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ch3bx1braiM"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4388C2",
    fillRule: "nonzero",
    d: "M2.466 3.544L5.55 1.75c.08.082.158.165.237.249L2.703 3.792c-.079-.084-.157-.167-.237-.248",
    mask: "url(#vxpimwqswiN)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "006fz2tgiiP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0nla0qm5uiO"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#448CC6",
    fillRule: "nonzero",
    d: "M2.702 3.792l3.085-1.793.225.25-3.084 1.792-.226-.25",
    mask: "url(#006fz2tgiiP)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "tg82idw49iR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2avkcyb3hiQ"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5D96CC",
    fillRule: "nonzero",
    d: "M2.928 4.041L6.012 2.25c.075.086.15.173.224.262L3.152 4.304c-.074-.089-.149-.177-.224-.263",
    mask: "url(#tg82idw49iR)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "p0gphsrqliT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6fytnp5g1iS"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#669ACE",
    fillRule: "nonzero",
    d: "M3.152 4.303l3.084-1.792c.075.09.15.183.223.276L3.375 4.58c-.074-.094-.148-.186-.223-.277",
    mask: "url(#p0gphsrqliT)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "7weyiwkf0iV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eg8sngsygiU"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6D9DD0",
    fillRule: "nonzero",
    d: "M3.375 4.58l3.084-1.793c.087.111.173.224.257.337L3.632 4.917c-.084-.114-.17-.226-.257-.338",
    mask: "url(#7weyiwkf0iV)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "pzpamuycgiX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yiiwyvfywiW"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#72A1D2",
    fillRule: "nonzero",
    d: "M3.632 4.917l3.084-1.793c.126.171.248.346.367.523L3.999 5.44c-.119-.177-.241-.35-.367-.522",
    mask: "url(#pzpamuycgiX)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "wg6pgigcliZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6h6gbm54uiY"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#77A3D3",
    fillRule: "nonzero",
    d: "M3.999 5.44l3.084-1.793c.15.224.293.452.43.685L4.43 6.125c-.137-.233-.28-.462-.43-.686",
    mask: "url(#wg6pgigcliZ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "iocfzy7v0jb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fci04uljuja"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#72A1D2",
    fillRule: "nonzero",
    d: "M4.429 6.125l3.084-1.793c.099.168.194.337.285.508L4.714 6.633c-.091-.171-.187-.34-.285-.508",
    mask: "url(#iocfzy7v0jb)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "37eplhlcsjd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2odantpaqjc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6D9DD0",
    fillRule: "nonzero",
    d: "M4.714 6.633L7.798 4.84c.062.116.122.231.18.348L4.892 6.98c-.058-.116-.118-.232-.179-.347",
    mask: "url(#37eplhlcsjd)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "2qf8q0iigjf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9121ssbf6je"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#669ACE",
    fillRule: "nonzero",
    d: "M4.893 6.98l3.085-1.792c.05.102.1.204.148.306L5.04 7.286c-.047-.103-.097-.204-.148-.306",
    mask: "url(#2qf8q0iigjf)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "2q4k9w98hjh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#78ebwmoqijg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5D96CC",
    fillRule: "nonzero",
    d: "M5.041 7.286l3.085-1.792c.043.093.086.186.127.28L5.169 7.565c-.042-.094-.084-.187-.128-.28",
    mask: "url(#2q4k9w98hjh)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "easdx6xtsjj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9bowd7c1iji"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#448CC6",
    fillRule: "nonzero",
    d: "M5.169 7.566l3.084-1.793c.04.092.08.184.118.276L5.287 7.842c-.038-.093-.078-.184-.118-.276",
    mask: "url(#easdx6xtsjj)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "lo6mqjo43jl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ed5el1fkojk"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4388C2",
    fillRule: "nonzero",
    d: "M5.287 7.842l3.084-1.793c.039.094.077.188.113.282L5.401 8.123l-.114-.281",
    mask: "url(#lo6mqjo43jl)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mqr8z8cf6jn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vhwh31vqbjm"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4286BE",
    fillRule: "nonzero",
    d: "M5.4 8.123L8.486 6.33c.036.095.072.19.106.284L5.507 8.406c-.034-.094-.07-.189-.106-.283",
    mask: "url(#mqr8z8cf6jn)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "2vcymof2xjp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#27k4zebezjo"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4184BB",
    fillRule: "nonzero",
    d: "M5.507 8.407L8.59 6.614c.036.099.07.197.103.295L5.61 8.701c-.033-.098-.068-.196-.103-.294",
    mask: "url(#2vcymof2xjp)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "oq4ogk2gujr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2pc8how92jq"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4082B8",
    fillRule: "nonzero",
    d: "M5.61 8.701L8.694 6.91l.096.3L5.705 9c-.03-.1-.062-.2-.095-.3",
    mask: "url(#oq4ogk2gujr)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "ia13jx1fpjt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#crxbgrzk7js"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3F80B5",
    fillRule: "nonzero",
    d: "M5.706 9.001L8.79 7.208l.09.306-3.085 1.793c-.029-.102-.058-.204-.09-.306",
    mask: "url(#ia13jx1fpjt)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "i8mbbh994jv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#le04zlrj6ju"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3E7EB3",
    fillRule: "nonzero",
    d: "M5.795 9.307L8.88 7.514c.029.103.056.205.08.307L5.877 9.614c-.026-.102-.052-.205-.08-.307",
    mask: "url(#i8mbbh994jv)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "ipypeefqijx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7xop7zl7bjw"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3C7CB0",
    fillRule: "nonzero",
    d: "M5.876 9.614L8.96 7.82c.025.102.049.203.07.304L5.948 9.917c-.023-.1-.046-.202-.071-.303",
    mask: "url(#ipypeefqijx)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "kkzk5fibsjz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7ememxwgbjy"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3B7AAD",
    fillRule: "nonzero",
    d: "M5.946 9.917l3.085-1.793c.022.101.042.202.061.303l-3.084 1.792c-.02-.1-.04-.201-.062-.302",
    mask: "url(#kkzk5fibsjz)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "bp2iqams5jB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y4mx75xwejA"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3A78AA",
    fillRule: "nonzero",
    d: "M6.008 10.219l3.084-1.792c.018.097.035.195.05.292l-3.084 1.793c-.015-.098-.032-.196-.05-.293",
    mask: "url(#bp2iqams5jB)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "2280s2u2jjD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#76g038vz7jC"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3975A7",
    fillRule: "nonzero",
    d: "M6.058 10.512l3.085-1.793c.015.097.028.194.04.29L6.1 10.803c-.012-.097-.026-.194-.042-.29",
    mask: "url(#2280s2u2jjD)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "l8l809nwqjF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ge28rncgajE"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3873A4",
    fillRule: "nonzero",
    d: "M6.1 10.802l3.084-1.793c.012.095.023.19.031.284l-3.084 1.792c-.009-.094-.02-.188-.031-.283",
    mask: "url(#l8l809nwqjF)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mxchshsqrjH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zsvwf9psqjG"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3771A1",
    fillRule: "nonzero",
    d: "M6.131 11.085l3.084-1.792c.009.094.016.188.023.281l-3.085 1.793c-.006-.094-.013-.187-.022-.282",
    mask: "url(#mxchshsqrjH)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "hhux8mzhxjJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#352e4qmdgjI"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#356F9E",
    fillRule: "nonzero",
    d: "M6.153 11.367l3.085-1.793c.006.094.01.188.013.28l-3.085 1.793c-.002-.093-.007-.186-.013-.28",
    mask: "url(#hhux8mzhxjJ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "hvsexi2ahjL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fhw1vxyuxjK"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#346C9A",
    fillRule: "nonzero",
    d: "M6.166 11.647l3.085-1.793c.002.087.004.174.003.261v.017L6.17 11.924v-.016c0-.087-.001-.174-.004-.261",
    mask: "url(#hvsexi2ahjL)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "vsqltknxjjN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0inkol3cljM"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#336A97",
    fillRule: "nonzero",
    d: "M6.17 11.924l3.084-1.792c0 .095-.002.188-.006.28l-3.085 1.792c.004-.092.006-.185.007-.28",
    mask: "url(#vsqltknxjjN)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "i8gg7tfssjP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#58wmheiixjO"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#316894",
    fillRule: "nonzero",
    d: "M6.164 12.204l3.084-1.792c-.004.092-.01.184-.017.273l-3.085 1.792c.008-.09.014-.18.018-.273",
    mask: "url(#i8gg7tfssjP)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "64i5pxyvwjR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nvoyg50shjQ"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#306591",
    fillRule: "nonzero",
    d: "M6.146 12.477l3.085-1.792c-.008.095-.017.188-.029.279l-3.084 1.793c.011-.092.02-.185.028-.28",
    mask: "url(#64i5pxyvwjR)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "yzht8vvpkjT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#us60wq3psjS"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E638E",
    fillRule: "nonzero",
    d: "M6.118 12.757l3.084-1.793c-.012.094-.025.187-.041.277l-3.085 1.792c.016-.09.03-.182.042-.276",
    mask: "url(#yzht8vvpkjT)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "zfi74hbbxjV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f6i6arzozjU"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2D618B",
    fillRule: "nonzero",
    d: "M6.076 13.033l3.085-1.792c-.017.097-.036.19-.057.283L6.02 13.316c.02-.092.04-.186.056-.283",
    mask: "url(#zfi74hbbxjV)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "t4ex5nygkjX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h5azijsnvjW"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2B5E87",
    fillRule: "nonzero",
    d: "M6.02 13.317l3.084-1.793c-.023.102-.05.2-.077.296l-3.084 1.793c.027-.097.053-.195.077-.296",
    mask: "url(#t4ex5nygkjX)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "j2c7si0yxjZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ysoz5dgarjY"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2A5C84",
    fillRule: "nonzero",
    d: "M5.942 13.612l3.085-1.792c-.031.105-.065.207-.101.305L5.84 13.917c.037-.098.07-.2.101-.305",
    mask: "url(#j2c7si0yxjZ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "jcm5ely9zkb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9bobmhp6kka"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#285981",
    fillRule: "nonzero",
    d: "M5.841 13.917l3.085-1.793c-.043.115-.09.225-.14.33l-3.084 1.793c.05-.106.096-.215.14-.33",
    mask: "url(#jcm5ely9zkb)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "0uk0d5xixkd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1zo4ilzvpkc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#26577E",
    fillRule: "nonzero",
    d: "M5.702 14.247l3.084-1.793c-.066.14-.138.272-.218.397l-3.085 1.792c.08-.124.153-.257.22-.396",
    mask: "url(#0uk0d5xixkd)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "w8t0orglwkf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eft0auexzke"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#25557B",
    fillRule: "nonzero",
    d: "M5.484 14.643l3.084-1.793c-.268.42-.606.75-1.003.98l-3.084 1.792c.396-.23.735-.559 1.003-.98",
    mask: "url(#w8t0orglwkf)"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CECDCC",
    d: "M12.938 19.282c-3.197-1.846-5.78-6.322-5.77-9.998.01-3.673 2.611-5.155 5.808-3.31 3.199 1.847 5.783 6.323 5.773 9.996-.01 3.676-2.612 5.159-5.811 3.312m.043-15.054C6.16.29.885 5.236.607 5.496c.275.58 5.506 11.591 12.326 15.529 6.82 3.938 12.095-1.008 12.373-1.269-.275-.58-5.505-11.59-12.325-15.528",
    transform: "translate(21 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082049",
    d: "M8.362 12.062v.001l.001.005-.001-.006",
    transform: "translate(21 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2161AC",
    d: "M9.722 11.585l1.416.818c.043.15.095.302.157.45l-1.387-.8-.416.666-1.129-.651-.01-.04-.03-.103-.012-.046-.032-.126-.009-.034c-.005-.024-.01-.048-.017-.072l1.053.608.416-.67z",
    transform: "translate(21 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B2439",
    d: "M11.294 12.853c-.06-.149-.113-.3-.156-.45l.369.213-.001.359-.212-.122z",
    transform: "translate(21 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082049",
    d: "M17.65 17.073c-.004.016-.01.031-.015.046l.016-.046",
    transform: "translate(21 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2161AC",
    d: "M17.66 13.606l-1.05-.607-.415.67-1.42-.82c-.042-.149-.094-.298-.154-.445l1.387.8.417-.67 1.126.65.012.044.026.097.014.05.03.118.012.045.016.068",
    transform: "translate(21 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#123155",
    d: "M28.354 17.888l-.018-.037-.045-.094-.033-.068-.051-.105-.05-.1-.033-.068-.032-.062-.057-.115-.082-.162-.067-.13-.097-.19-.074-.144-.116-.22-.08-.151-.015-.03-.08-.147-.138-.257c-.035-.067-.074-.136-.112-.205-.047-.088-.095-.174-.145-.265l-.126-.226-.156-.277-.138-.241c-.055-.098-.11-.195-.169-.295l-.045-.078-.067-.113c-.099-.17-.2-.341-.306-.517l-.12-.2c-.141-.234-.286-.471-.438-.714l-.016-.027c-.146-.233-.297-.47-.451-.709-.048-.072-.096-.145-.143-.219-.125-.19-.251-.381-.38-.574l-.096-.144c-.016-.023-.033-.046-.048-.07-.168-.246-.339-.494-.515-.743l-.041-.058c-.163-.23-.33-.459-.499-.689l-.064-.09-.085-.11c-.197-.265-.399-.53-.605-.792l-.065-.086-.025-.031c-.189-.24-.381-.477-.577-.713l-.03-.036-.151-.178c-.125-.148-.25-.295-.376-.44l-.063-.075-.177-.195c-.105-.119-.21-.236-.318-.352l-.083-.093c-.06-.065-.122-.128-.183-.192-.096-.101-.19-.203-.288-.302-.03-.032-.06-.065-.092-.097-.066-.067-.132-.13-.198-.196-.088-.088-.176-.177-.266-.263l-.088-.088c-.073-.07-.147-.136-.22-.204-.085-.08-.171-.161-.258-.24-.025-.022-.049-.046-.074-.07-.1-.089-.2-.174-.3-.262l-.179-.156-.038-.033c-.17-.143-.34-.282-.512-.418l-.012-.01-.062-.047c-.132-.103-.264-.204-.397-.303l-.098-.069-.17-.122-.2-.143-.239-.157c-.04-.027-.08-.054-.122-.08l-.065-.044c-.143-.091-.286-.179-.43-.264l-.1-.058c-.107-.062-.215-.122-.321-.18-.139-.075-.277-.145-.414-.213l-.076-.036-.087-.041c-.086-.041-.171-.083-.257-.12-.145-.066-.29-.127-.434-.184-.018-.008-.036-.014-.055-.021l-.08-.03c-.099-.038-.198-.077-.295-.111-.147-.052-.292-.098-.436-.142l-.029-.01c-.004 0-.007-.002-.01-.004-.159-.047-.315-.09-.47-.13-.068-.016-.135-.028-.202-.044l-.184-.04c-.05-.01-.1-.024-.151-.033-.159-.031-.315-.055-.47-.077-.023-.004-.046-.009-.07-.012l-.015-.002c-.208-.028-.414-.049-.616-.063-.017-.001-.033 0-.05-.002-.118-.007-.232-.007-.348-.01-.105-.004-.212-.011-.314-.01l-.047.001c-.26.003-.514.015-.762.037h-.015c-.197.019-.39.044-.58.073l-.164.028c-.085.015-.172.027-.256.044-.04.008-.075.019-.115.027-.153.032-.302.068-.45.106-.074.02-.15.037-.222.057-.184.052-.362.108-.537.167l-.08.026-.013.004c-.108.038-.21.08-.314.12-.074.028-.151.055-.223.084-.11.046-.215.094-.32.141-.06.027-.123.053-.181.08-.114.053-.22.108-.328.163-.045.023-.093.045-.137.069-.149.077-.29.156-.426.235L2.427 4.174c.135-.078.277-.157.425-.235l.152-.076c.103-.052.204-.104.313-.155.06-.028.125-.055.186-.082.104-.047.207-.094.316-.139.072-.03.15-.057.225-.086.103-.04.204-.08.312-.118.03-.011.063-.02.094-.03.174-.06.352-.116.536-.167.072-.021.148-.038.222-.057.147-.038.297-.075.45-.106.122-.026.245-.05.371-.071l.165-.029c.194-.03.391-.054.594-.072.248-.023.502-.034.761-.037.12-.001.241.004.362.007.115.004.23.004.348.012.224.014.45.035.682.067l.068.01c.205.03.413.068.622.112.06.012.122.026.184.04.225.052.451.108.682.177l.03.01c.24.074.484.159.73.253l.08.03c.246.097.494.206.745.325l.087.041c.268.13.538.272.811.43.2.115.399.237.596.365l.122.08c.147.098.293.197.438.3l.172.122c.165.12.33.245.493.372.02.017.042.032.063.048.188.149.376.303.561.46l.18.157c.125.11.25.219.374.332.087.078.172.159.258.24.103.096.206.192.308.291.09.087.177.175.266.264.097.096.194.193.29.292.097.1.193.201.289.303.089.095.178.189.265.284.107.116.213.235.319.353.08.09.16.178.238.268.128.147.254.295.38.444l.177.21c.196.237.389.476.578.715l.088.114c.208.264.41.53.608.796.05.066.1.131.147.197.17.23.337.46.5.69.014.02.027.04.041.058.176.25.348.498.515.745l.142.211c.13.194.258.386.382.577l.141.216c.157.243.31.483.457.718l.011.017c.152.244.297.48.438.715l.122.203.305.515.112.192.169.294.138.24.153.275.13.231c.049.088.095.173.14.258.04.07.08.142.116.21l.134.25.1.187c.026.048.05.092.073.139l.121.23.073.141c.035.067.07.133.1.194l.064.125.084.165c.02.04.038.079.058.116l.064.13.05.099c.017.038.035.073.051.106.01.023.023.047.033.068l.045.093.018.037.036.076c-.023.022-.081.076-.172.155-.272.237-.84.697-1.648 1.168h.001l3.083-1.793c1.079-.627 1.728-1.235 1.82-1.322l-.036-.076",
    transform: "translate(21 32)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicServices);
export default __webpack_public_path__ + "static/media/Public_Services.4322b488c4129b4e810bdfb6f42436a2.svg";
export { ForwardRef as ReactComponent };